import moment from "moment";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { isValidPhoneNumber } from 'react-phone-number-input';
import AlertManager from '../Alerts/alertManagerFrontend.js';
import GraphOneBar from '../Common/GraphOneBar.js';
import GraphOneCurve from '../Common/GraphOneCurve.js';
import GraphThreeCurves from '../Common/GraphThreeCurves.js';
import GraphTwoCurves from '../Common/GraphTwoCurves.js';
import GraphUsageSessions from '../Common/GraphUsageSessions.js';

import back from '../../Images/Position/back.png';
import belly from '../../Images/Position/belly.png';
import leftSide from '../../Images/Position/left-side.png';
import rightSide from '../../Images/Position/right-side.png';
import stand from '../../Images/Position/stand.png';
import upsideDown from '../../Images/Position/upside-down.png';



//Function to convert the hour to a date with the right UTC hours and minutes
//Input: string of hours and minutes (format hh:mm)
//Output: date
const convert_hour_to_utc_date = (hour) => {
    let date_with_hour = "2024-01-01T" + hour + ":00"
    date_with_hour = new Date(date_with_hour)
    let return_date = new Date()
    return_date.setUTCHours(date_with_hour.getUTCHours());
    return_date.setUTCMinutes(date_with_hour.getUTCMinutes());
    return_date.setUTCSeconds(0);
    return_date.setUTCMilliseconds(0);

    return (return_date);
}


//Function to convert the isostring to a string usable by time inputs and converted to the local hour
//Input: isostring
//Output: string in format "hh:mm"
const convert_datestring_to_timeinput_string = datestring => {
    let ret = ""
    let date = new Date(datestring)
    if (!isNaN(date.getTime())) {
        let hours = date.getHours()
        let minutes = date.getMinutes()
        if (hours < 10) {
            hours = "0"+hours
        }
        if (minutes < 10) {
            minutes = "0"+minutes
        }
        ret = hours + ':' + minutes
    }
    return ret

}

const convertRoleToText = (value, readOnly) => {
    let ret = ""

    switch (value) {
        case "admin":
            if (readOnly) {
                ret = <><FormattedMessage id="account.role.admin" defaultMessage="Admin" />  - promoteur</>
            }
            else {
                ret = <FormattedMessage id="account.role.admin" defaultMessage="Admin" />
            }            
            break

        case "staff":
            if (readOnly) {
                ret = <><FormattedMessage id="account.role.staff" defaultMessage="Staff" />  - promoteur</>
            }
            else {
                ret = <FormattedMessage id="account.role.staff" defaultMessage="Staff" />
            }              
            break

        case "registered":
            ret = <FormattedMessage id="account.role.registered" defaultMessage="Patient" />
            break
    }
    return (ret)
}

const convertYesNoMaybe = (value) => {
    let ret
    switch (value) {
        case -1:
        case "-1":
            ret = "-"
            break
        case 0:
        case "0":
            ret = <FormattedMessage id="monitoring.switch.label.no" defaultMessage="No" />
            break
        case 1:
        case "1":
            ret = <FormattedMessage id="monitoring.switch.label.yes" defaultMessage="Yes" />
            break
    }
    return (ret)
}

//Function to set current time line in graphs
//Input: endDate
//Output: 2 point line
const setCurrentTimePoint = (endDate) => {

    let testDate = new Date(endDate)

    let local_data = [];
    if (Utils.isSameDay(new Date(), endDate)) {
        local_data = [{x: new Date().getTime(), y: -1000 }, {x: new Date().getTime(), y: 1000 }];
    }
    else{
        local_data = "";
    }
    return (local_data)   
}   



//Function to set alert curve within graphs
//Input: start date, end date and alert level
//Output: tab of 2 points
const setAlertCurve = (startDate, endDate, alert_level) => {

    let local_data = [];

    if (Utils.isSameDay(new Date(), endDate)) {
        local_data = [{x: startDate.getTime(), y: alert_level }, {x: new Date().getTime(), y: alert_level }];      
    }
    else{
        local_data = [{x: startDate.getTime(), y: alert_level }, {x: endDate.getTime(), y: alert_level }];      
    }  
    return (local_data)   
}

//Function to return the color according to hex value
const getConvertedColor = (colorValue) => {

    if(colorValue === "#21BA45"){
        return ("green");
    }
    else if(colorValue === "#F2711C"){
        return ("orange");
    }
    else if(colorValue === "#DB2828"){
        return ("red");
    }
    else{
        return ("grey");
    }
}

const isValidJson = (s) => {
    try {
        JSON.parse(s);
        return true;
    } catch (e) {
        return false;
    }
}

const setDefaultThreshold2 = (type) => {
    let ret;
    switch (type) {
        case "temperature":
            ret = -274
            break
        case "breathing_leak":
        case "breathing_rate":
        case "MDASI":
            ret = -20
            break
        case "pulse_rate":
        case "tension":
        case "scale":
            ret = 0
            break
        case "breathing_usage":
            ret = 30
            break
        case "EQ5D":
        case "EQ5DHealthscale":
            ret = 100
            break
        case "spo2":
            ret = 120
            break
    }
    return ret;
}

//Function to set measurementvalue color
//Input: value, threshold, OrangeShift, infOrSup
//Output: color
const setMeasureColor = (value, threshold, OrangeShift, infOrSup, threshold2) => {

    //Grey color
    if(value === "-"){
        return ('#767676');
    }
    else{

        var convertedThreshold = Number.parseFloat(threshold);
        var convertedThreshold2 = Number.parseFloat(threshold2);
        var convertedValue = Number.parseFloat(value);
        
        if (infOrSup == "sup"){
            //Green color
            if((convertedValue < (convertedThreshold - OrangeShift)) && (convertedValue > (convertedThreshold2 + OrangeShift))){
                return ("#21BA45");
            }
            //Orange color
            else if(((convertedValue >= (convertedThreshold - OrangeShift)) && (convertedValue < convertedThreshold)) || ((convertedValue <= (convertedThreshold2 + OrangeShift)) && (convertedValue > convertedThreshold2))){
                return ("#F2711C");
            }
            //Red color
            else if(convertedValue >= convertedThreshold || convertedValue <= convertedThreshold2){
                return ("#DB2828");
            }
        }
        else if (infOrSup == "inf"){

            //Green color
            if((convertedValue > (convertedThreshold + OrangeShift)) && (convertedValue < (convertedThreshold2 - OrangeShift))){
                return ("#21BA45");
                }
                //Orange color
            else if(((convertedValue <= (convertedThreshold + OrangeShift)) && (convertedValue > convertedThreshold)) || ((convertedValue >= (convertedThreshold2 - OrangeShift)) && (convertedValue < convertedThreshold2))){
                    return ("#F2711C");
                }
            //Red color
            else if(convertedValue <= convertedThreshold || convertedValue >= convertedThreshold2){
                return ("#DB2828");
                }
            }
            //Grey color
            else{
                return ('#767676');
            } 
        }
}



//Function to set last data measurement timer
//Input: dataset
//Output: formatetd string message
const setLastMeasurementTimer = (dataset) => {

    let timer = "-";

    if((dataset !== undefined)&&(dataset.length >0)){

        let date = new Date();
        let current_Date = new Date(
            date.getFullYear(),
            date.getMonth(), 
            date.getDate(), 
            date.getHours(), 
            date.getMinutes(), 
            date.getSeconds(), 
            date.getMilliseconds()
        );

        let last_Data_Date = new Date(dataset[dataset.length-1].x);

        //Comparison between last temperature retrieved date and current date (result in seconds)
        let secondsSinceLastData = ((Math.abs(current_Date - last_Data_Date)) / 1000);

        let minutes = Math.trunc(secondsSinceLastData/60);


        if(minutes >= 60){
            let heures = Math.floor(minutes/60)
            minutes = (minutes - heures * 60)

            timer = <FormattedMessage id="timer.hours" defaultMessage="" values={{heures: heures, minutes : minutes}}/>
        }
        else if (minutes >2) {
            timer =  <FormattedMessage id="timer.minutes" defaultMessage="" values={{minutes : minutes}}/>
        }
    }

    return (timer);
}

//Function to get a date in a form of a string YYYY-MM-DD
//Input: Date object
//Output: String
const convert_date_to_YMD_string = (date) => {

    var month = date.getMonth() +1;
    var day = date.getDate();
    var year = date.getFullYear();

    if (month < 10) {
        month = '0' + month;
    }
    if (day < 10) {
        day = '0' + day;
    }
    var stringDate = year + "-" + month + "-" + day;
    return (stringDate);
}

//Function to get a date in a form of a string DD-MM-YYYY
//Input: Date object
//Output: String
const convert_date_to_DMY_string = (date) => {

    var month = date.getMonth() +1;
    var day = date.getDate();
    var year = date.getFullYear();

    if (month < 10) {
        month = '0' + month;
    }
    if (day < 10) {
        day = '0' + day;
    }
    var stringDate = day + "-" + month + "-" + year;
    return (stringDate);
}

//Function to get a date in a form of a string day
//Input: Date object
//Output: String
const convert_date_to_full_date_string = (date) => {
    if (date === undefined) {
        return ("")
    }
    let convert = []
    convert = date.split('-');
    if (convert.length === 0) {
        convert = date.split('/');
    }
    if (convert[0].length !== 4) {
        convert = convert.reverse();
        date = convert.join('-')
    }

    let UTC_date = new Date(date.split('T')[0]);
    let ret
    ret = UTC_date.toLocaleDateString(moment.locale(navigator.language))
    return(ret)
}

//Function to get a date in a form of a string day
//Input: Date object
//Output: String
const convert_date_to_full_date_string_hepadom = (date) => {
    if (date === undefined) {
        return ("")
    }
    let convert = []
    convert = date.split('-');
    if (convert.length === 0) {
        convert = date.split('/');
    }
    if (convert[0].length !== 4) {
        convert = convert.reverse();
        date = convert.join('-')
    }

    let UTC_date = new Date(date.split('T')[0]);
    let ret
    ret = UTC_date.toLocaleDateString(moment.locale(navigator.language))
    ret = ret.slice(3)
    return(ret)
}

//Function to get a date in a form of a string day
//Input: Date object
//Output: String
const convert_date_to_full_datetime_string = (date) => {
    let UTC_date = new Date(date);
    let ret = UTC_date.toLocaleDateString(moment.locale(navigator.language))
    ret += " " + UTC_date.getHours();
    ret += ":" + UTC_date.getMinutes();
    ret += ":" + UTC_date.getSeconds();
    return(ret)
}

const isSameDay = (d1, d2) => {
    if ( (d1.getDate() === d2.getDate()) && (d1.getMonth() === d2.getMonth()) && (d1.getFullYear() === d2.getFullYear()) ){
        return true;
    }
    else {
        return false;
    }
}

//Function to split a string with several elements separated by a common separator in an array list
//Input: the string to split, the separator marker, boolean to indicate if spaces must be removed in each splitted element
//Output: array
const splitStringToList = (string, separator, removeSpaces) => {

    var list = [];

    if(string.length > 0){
       list = string.split(separator); 
    }

    if(removeSpaces){
        for(var i=0; i<list.length; i++){
            list[i] = list[i].trim();
        }
    }

    return list;    
}

//Function to test the group filters
const testGroupsFilter = (selected_filter, patient_group) => {

    let ret = false
    selected_filter = JSON.parse(selected_filter).id;
    //First, testing if both groups are the same
    if (selected_filter === patient_group) {
        ret = true
    }
    //Then, testing the "no group" case
    else if (selected_filter === "nogroup" && patient_group === "null") {
        ret = true
    }
    //Finally, testing the "All patient" case
    else if (selected_filter === "null") {
        ret = true
    }
    return ret
}

//Function to convert to local hours
const reminderAlertHoursConvert = (reminder_list) => {
    let ret = reminder_list;
    if (ret !== undefined) {
        let i = 0;
        while (ret[i]) {
            if (ret[i].alert_hours !== undefined) {
                let hours_list = ret[i].alert_hours.split(',')
                let j = 0;
                while (hours_list[j]) {
                    let new_date = new Date();
                    new_date.setUTCHours(hours_list[j].split(':')[0])
                    new_date.setMinutes(hours_list[j].split(':')[1])
                    new_date.setTime(new_date.getTime() - (new_date.getTimezoneOffset()*60000))
                    let correct_hour = new_date.getUTCHours()
                    if (Number(correct_hour) < 10) {
                        correct_hour = "0" + correct_hour
                    }
                    let correct_minute = new_date.getUTCMinutes()
                    if (Number(correct_minute) < 10) {
                        correct_minute = "0" + correct_minute
                    }
                    hours_list[j] = correct_hour + ":" + correct_minute
                    j++;

                }
                hours_list.sort()
                ret[i].alert_hours = hours_list.join(',')
            }
            i++;
        }
    }
    return ret
}

//Function to use multiple numbers in sms_alert
const smsAlertParse = (sms_alert) => {
    let ret = [];
    if (sms_alert === undefined || sms_alert === null || sms_alert === "" || sms_alert === []) {
        return ([""]);
    }
    else {
    let i = 0;
    if (typeof(sms_alert) === "string") {
        ret = sms_alert.replace(' ', '').split(',');
        while (ret[i]) {
            if (ret[i][0] === '0') {
                let save = ret[i].slice(1);
                ret[i] = "+33" + save;
            }
            i++;
        }
    }
    else {
        ret = sms_alert;
    }
    }
    return ret
}

const fillReminder = (alerts_params, features) => {
    if (features !== undefined && checkBit(features, featureToBitNumber("breathing"))) {
        let oximeter_index = (alerts_params.findIndex(reminder => reminder.alert_type === "oximeter_reminder"));
        if (oximeter_index === -1) {
            alerts_params.push({
                alert_hours: "12:00",
                alert_type: "oximeter_reminder",
                last_search: "none",
                time_margin: 84
            })
        }
        let niv_index = (alerts_params.findIndex(reminder => reminder.alert_type === "niv_reminder"));
        if (niv_index === -1) {
            alerts_params[niv_index] = {
                alert_hours: "12:00",
                alert_type: "niv_reminder",
                last_search: "none",
                time_margin: 84
            }
        }
        let oxi_index = (alerts_params.findIndex(reminder => reminder.alert_type === "oxi_reminder"));
        if (oxi_index === -1) {
            alerts_params[oxi_index] = {
                alert_hours: "12:00",
                alert_type: "oxi_reminder",
                last_search: "none",
                time_margin: 84
            }
        }
    }
    return alerts_params
}

//Function to order the profiles by name2

const sortDataByNames = (profiles) => {
    profiles.sort((a,b)=> {
        const aLast = a.Patient_Data.lastname || '';
        const bLast = b.Patient_Data.lastname || '';
        const aFirst = a.Patient_Data.firstname || '';
        const bFirst = b.Patient_Data.firstname || '';
        return aLast.localeCompare(bLast) || aFirst.localeCompare(bFirst);
    });
}

const ins_check_if_data_exist = (patient_data) => {
    if (patient_data.INS_Data.NumIdentifiant !== undefined && patient_data.INS_Data.NumIdentifiant !== null && patient_data.INS_Data.NumIdentifiant !== "null" && patient_data.INS_Data.NumIdentifiant !== "") {
        return (false);
    }
    return (true)
}

const ins_check_valid_last_names = (to_check) => {
    let ret = true

    ret = to_check.toUpperCase()
    let test = ret.match(/[A-Z'’ -]/g)
    ret = ret.replace(/'/g, "\'")
    // check if that kind of char are authorized
    //ret = ret.replace(/’/g, "\'")

    //Le 1er caractère doit être différent de blanc (espace) et de tiret
    if (to_check[0] === ' ' || to_check[0] === '-') {
        ret = false
    }
    let i = 0
    while (to_check[i]) {
        //Blanc (espace) et apostrophe ne peuvent être doublés ou combinés
        if (((to_check[i] === " ") || (to_check[i] === "'")) && ((to_check[i+1] === " ") || (to_check[i+1] === "'"))) {
            ret = false
        }
        //Tirets ne peuvent être triplés
        else if (to_check[i] === '-' && to_check[i+1] === '-' && to_check[i+2] === '-') {
            ret = false
        }
        i++
    }
    if (test.length !== to_check.length) {
        ret = false
    }
    return ret
}

const ins_check_valid_first_names = (to_check) => {
    let ret = true

    ret = to_check.toUpperCase()
    let test = ret.match(/[A-Z'’ -]/g)
    ret = ret.replace(/'/g, "\'")
    // check if that kind of char are authorized
    //ret = ret.replace(/’/g, "\'")

    //Le 1er caractère doit être différent de blanc (espace) et de tiret
    if (to_check[0] === ' ' || to_check[0] === '-') {
        ret = false
    }
    //Le dernier caractère doit être différent du tiret et de l’apostrophe
    if (to_check[to_check.length - 1] === "'" || to_check[to_check.length - 1] === '-') {
        ret = false
    }
    let i = 0
    while (to_check[i]) {
        //Blanc (espace) et apostrophe ne peuvent être doublés
        if (((to_check[i] === " ") && (to_check[i+1] === " ")) || ((to_check[i] === "-") && (to_check[i+1] === "-"))) {
            ret = false
        }
        //Tirets ne peuvent être doublés
        else if (to_check[i] === '-' && to_check[i+1] === '-') {
            ret = false
        }
        i++
    }
    if (test.length !== to_check.length) {
        ret = false
    }
    return ret
}

const ins_check_valid_dates = (to_check) => {
    let ret = true

    var d = new Date(to_check),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    let to_check_string = [year, month, day].join('-');
    let test = to_check_string.match(/(?:\d{4})[-\/.](?:0[1-9]|1[012])[-\/.](?:0[1-9]|[12][0-9]|3[01])/g)

    if (test === null || test.length !== 1) {
        ret = false
    }
    return ret
}

const ins_check_valid_birthPlace = (to_check) => {
    let ret = true

    ret = to_check.toUpperCase()
    let test = ret.match(/[A-Z0-9]/g)
    if (test.length !== 5 || to_check.length !== 5) {
        ret =  false
    }
    return ret
}

const ins_check_valid_sex = (sex) => {
    let ret = false
    if (sex === "M" || sex === "F" || sex === "male" || sex === "female") {
        ret = true
    }
    return ret
}

const ins_convert_sex = (sex) => {
    if (sex === undefined || sex === "") {
        sex = "U"
    }
    sex = sex.toUpperCase()
    if (sex === "M" || sex === "MALE" || sex === "MR") {
        sex = "M"
    }
    else if (sex === "F" || sex === "FEMALE" || sex === "MS") {
        sex = "F"
    }
    else if (sex === "O" || sex === "OTHER") {
        sex = "O"
    }
    else {
        sex = "UNKNOWN"
    }
    return (sex)
}

const fhir_convert_user_data = (full_data) => {

    let ret = {
        FK_structure : full_data.FK_structure,
        sex : full_data.civility,
        birthdate: full_data.birthDate,
        LieuNaissance: full_data.birthPlace,
        email : full_data.email,
        firstName : full_data.firstName,
        group_display : full_data.group_display,
        id_user : full_data.identifier?.value,
        lastName : full_data.lastName,
        role : full_data.role,
        role_extra : full_data.role_extra,
        username: full_data.username,
        profession: full_data.profession || null,
        anonymised_patient: full_data.anonymised_patient,
        logs: full_data.logs,
        language: full_data.communication?.language?.text,
        readOnly: full_data.readOnly,
        struct_type: full_data.struct_type || null,
        rpps: full_data.rpps || null
    }
    if (full_data.ANS !== undefined) {
        ret.category = full_data.ANS.category
        ret.profession = full_data.ANS.profession
        ret.mssantemail= full_data.ANS.mssantemail        
    }
    // Fallback: surface category/profession coming directly from table_practitioner
    if (!ret.category && full_data.category) {
        ret.category = full_data.category
    }
    if (!ret.profession && full_data.profession) {
        ret.profession = full_data.profession
    }
    return (ret)
}

const fhir_get_structure_data = (full_data) => {
    let ret = {
        id_struct : full_data.FK_structure,
        struct_name : full_data.struct_name,
        struct_type : full_data.struct_type || null,
    }
    if (full_data.struct_hours_schedule !== undefined && full_data.struct_hours_schedule !== "") {
        let date_begin_utc = new Date(Date.UTC(0, 0, 0, 0, 0, 0))
        date_begin_utc.setUTCHours(full_data.struct_hours_schedule.day.split(',')[0].split(':')[0])
        date_begin_utc.setUTCMinutes(full_data.struct_hours_schedule.day.split(',')[0].split(':')[1])
        date_begin_utc.setTime(date_begin_utc.getTime() - (60000 * new Date().getTimezoneOffset()))
        let date_end_utc = new Date(Date.UTC(0, 0, 0, 0, 0, 0))
        date_end_utc.setUTCHours(full_data.struct_hours_schedule.day.split(',')[1].split(':')[0])
        date_end_utc.setUTCMinutes(full_data.struct_hours_schedule.day.split(',')[1].split(':')[1])
        date_end_utc.setTime(date_end_utc.getTime() - (60000 * new Date().getTimezoneOffset()))
        let day_time = date_begin_utc.toISOString().split('T')[1].substring(0, 5) + ',' + date_end_utc.toISOString().split('T')[1].substring(0, 5)
        let night_time = date_end_utc.toISOString().split('T')[1].substring(0, 5) + ',' + date_begin_utc.toISOString().split('T')[1].substring(0, 5)
        ret.hours_schedule = {day: day_time, night: night_time}
    }
    if (ret.features === undefined || ret.features === null) {
        ret.features = 1;
    }
    return (ret)
}

const fhir_get_subscription_data = (full_data) => {
    let new_date = new Date(full_data.expiration_date)
    full_data.expiration_date = ("0" + new_date.getDate()).slice(-2) + '/' + ("0" + (new_date.getMonth()+1)).slice(-2) + '/' + new_date.getFullYear()
    let ret = {
        id_subscription : full_data.subscription.id_subscription,
        sub_total : full_data.subscription.sub_total,
        sub_used : full_data.subscription.sub_used,
        expiration_date: full_data.subscription.expiration_date,
        features: full_data.subscription.features
    }
    if (ret.features === undefined || ret.features === null) {
        ret.features = 1;
    }
    return (ret)
}

const ins_format_log = (log) => {
    let values = JSON.parse(log.logValue)
    let ret
    if (values.action === "get_ins_patient") {
        let formattedData = values.ins_firstname + " " + values.ins_lastname + ", INS: " + values.ins_num + values.ins_cle;
        ret = <FormattedMessage id="log.create_ins_patient" defaultMessage="" values={{date: convert_date_to_full_datetime_string(log.logDate), patient_data: formattedData}}/>
    }
    else if (values.action === "reading_data_from_ins_patient") {
        let formattedPatientData = values.ins_firstname + " " + values.ins_lastname + ", INS: " + values.ins_num + values.ins_cle;
        let formattedUserData = values.user_firstname + " " + values.user_lastname + "/" + values.username;
        ret = <FormattedMessage id="log.reading_data_from_ins_patient" defaultMessage="" values={{date: convert_date_to_full_datetime_string(log.logDate), patient_data: formattedPatientData, user_data: formattedUserData}}/>
    }
    else if (values.action === "share_to_ins_patient") {
        let formattedPatientData = values.ins_firstname + " " + values.ins_lastname + ", INS: " + values.ins_num + values.ins_cle;
        let formattedUserData = values.user_target_user_firstname + " " + values.user_target_user_lastname + "/" + values.user_target_username;
        ret = <FormattedMessage id="log.share_to_ins_patient" defaultMessage="" values={{date: convert_date_to_full_datetime_string(log.logDate), patient_data: formattedPatientData, user_data: formattedUserData}}/>
    }
    else if (values.action === "share_from_ins_patient") {
        let formattedPatientData = values.ins_firstname + " " + values.ins_lastname + ", INS: " + values.ins_num + values.ins_cle;
        let formattedUserData = values.user_origin_user_firstname + " " + values.user_origin_user_lastname + "/" + values.user_origin_username;
        ret = <FormattedMessage id="log.share_to_ins_patient" defaultMessage="" values={{date: convert_date_to_full_datetime_string(log.logDate), patient_data: formattedPatientData, user_data: formattedUserData}}/>
    }
    else if (values.action === "sms_alert_from_ins_patient") {
        let formattedPatientData = values.ins_firstname + " " + values.ins_lastname + ", INS: " + values.ins_num + values.ins_cle;
        let formattedUserData = values.user_firstname + " " + values.user_lastname + "/" + values.username;
        ret = <FormattedMessage id="log.sms_alert_from_ins_patient" defaultMessage="" values={{date: convert_date_to_full_datetime_string(log.logDate), patient_data: formattedPatientData, user_data: formattedUserData, phone_list: values.phone_number_list}}/>
    }
    else if (values.action === "mail_alert_from_ins_patient") {
        let formattedPatientData = values.ins_firstname + " " + values.ins_lastname + ", INS: " + values.ins_num + values.ins_cle;
        let formattedUserData = values.user_firstname + " " + values.user_lastname + "/" + values.username;
        ret = <FormattedMessage id="log.mail_alert_from_ins_patient" defaultMessage="" values={{date: convert_date_to_full_datetime_string(log.logDate), patient_data: formattedPatientData, user_data: formattedUserData, mail_list: values.mail_list}}/>
    }
    else if (values.action === "http_request_alert_from_ins_patient") {
        let formattedPatientData = values.ins_firstname + " " + values.ins_lastname + ", INS: " + values.ins_num + values.ins_cle;
        let formattedUserData = values.user_firstname + " " + values.user_lastname + "/" + values.username;
        ret = <FormattedMessage id="log.http_request_alert_from_ins_patient" defaultMessage="" values={{date: convert_date_to_full_datetime_string(log.logDate), patient_data: formattedPatientData, user_data: formattedUserData, adress_list: values.adress_list}}/>
    }
    return (ret);
}

const ins_format_data = (ins_data) => {
    let ret = {"INS_Data":{}}
    ret.id = ins_data.id;
    ret.username = ins_data.username;
    if (ins_data.INS_Data !== undefined && ins_data.INS_Data.NumIdentifiant !== undefined && ins_data.INS_Data.Cle !== undefined) {
        ret.INS_Data.NumIdentifiant = ins_data.INS_Data.NumIdentifiant + ins_data.INS_Data.Cle;
    }
    else {
        ret.INS_Data.NumIdentifiant = "";
    }
    if (ins_data.INS_Data !== undefined && ins_data.INS_Data.OID !== undefined) {
        ret.INS_Data.OID = ins_data.INS_Data.OID;
    }
    else {
        ret.INS_Data.OID = "";
    }

    if (ins_data.INS_Data !== undefined) {
        ret.INS_Data.Cle = ins_data.INS_Data.Cle;
    }

    if (ins_data.INS_Data === undefined || ins_data.lastname === undefined || ins_data.lastname === null || ins_data.lastname === "null" || ins_data.lastname === ""){
        ret.lastName = ins_data.lastName
    }
    else {
    ret.lastName = ins_data.lastname
    }
    if (ins_data.INS_Data === undefined || ins_data.firstname === undefined || ins_data.firstname === null || ins_data.firstname === "null" || ins_data.firstname === ""){
        ret.firstName = ins_data.firstName
    }
    else {
    ret.firstName = ins_data.firstname
    }
    if (ins_data.INS_Data === undefined || ins_data.logs === undefined || ins_data.logs === null || ins_data.logs === "null" || ins_data.logs === "") {
        ret.logs = []
    }
    else {
        ret.logs = JSON.parse(ins_data.logs)
        ret.logs.sort(function(a,b){
          return new Date(b.date) - new Date(a.date);
        });

    }

    if (ins_data.INS_Data === undefined || ins_data.INS_Data.NomNaissance === undefined || ins_data.INS_Data.NomNaissance === null || ins_data.INS_Data.NomNaissance === "null" || ins_data.INS_Data.NomNaissance === "") {
        ret.INS_Data.NomNaissance = ins_data.lastname
    }
    else {
        ret.INS_Data.NomNaissance = ins_data.INS_Data.NomNaissance
    }

    if (ins_data.INS_Data === undefined || ins_data.INS_Data.PrenomNaissance === undefined || ins_data.INS_Data.PrenomNaissance === null || ins_data.INS_Data.PrenomNaissance === "null" || ins_data.INS_Data.PrenomNaissance === "") {
        ret.INS_Data.PrenomNaissance = ret.firstName
    }
    else {
        ret.INS_Data.PrenomNaissance = ins_data.INS_Data.PrenomNaissance
    }

    if (ins_data.INS_Data === undefined || ins_data.INS_Data.NomUtilise === undefined || ins_data.INS_Data.NomUtilise === null || ins_data.INS_Data.NomUtilise === "null" || ins_data.INS_Data.NomUtilise === "") {
        ret.INS_Data.NomUtilise = ret.NomNaissance;
    }
    else {
        ret.INS_Data.NomUtilise = ins_data.INS_Data.NomUtilise;
    }

    if (ins_data.INS_Data === undefined || ins_data.INS_Data.PrenomUtilise === undefined || ins_data.INS_Data.PrenomUtilise === null || ins_data.INS_Data.PrenomUtilise === "null" || ins_data.INS_Data.PrenomUtilise === "") {
        ret.INS_Data.PrenomUtilise = ret.INS_Data.PrenomNaissance;
    }
    else {
        ret.INS_Data.PrenomUtilise = ins_data.INS_Data.PrenomUtilise;
    }

    // Registered users without INS data can have an undefined PrenomNaissance; guard the split.
    ret.INS_Data.PremierPrenom = (ret.INS_Data.PrenomNaissance || "").split(' ')[0]


    if (ins_data.INS_Data !== undefined && ins_data.INS_Data.DateNaissance !== undefined && ins_data.INS_Data.DateNaissance !== null && ins_data.INS_Data.DateNaissance !== "null" && ins_data.INS_Data.DateNaissance !== "") {
        ret.INS_Data.DateNaissance = ins_data.INS_Data.DateNaissance;
    }
    else if (ins_data.birthdate !== undefined && ins_data.birthdate !== null && ins_data.birthdate !== "null" && ins_data.birthdate !== "") {
        ret.INS_Data.DateNaissance = ins_data.birthdate.split('T')[0];
    }

    if (ins_data.INS_Data === undefined || ins_data.INS_Data.Sex === undefined || ins_data.INS_Data.Sex === null || ins_data.INS_Data.Sex === "null" || ins_data.INS_Data.Sex === "") {
        ret.INS_Data.Sex = ins_data.sex;
    }
    else {
        ret.INS_Data.Sex = ins_data.INS_Data.Sex;
    }

    ret.INS_Data.Sex = ins_convert_sex(ret.INS_Data.Sex);

    if (ins_data.INS_Data === undefined || ins_data.INS_Data.LieuNaissance === undefined || ins_data.INS_Data.LieuNaissance === null || ins_data.INS_Data.LieuNaissance === "null" || ins_data.INS_Data.LieuNaissance === "") {
        ret.INS_Data.LieuNaissance = "";
    }
    else {
        ret.INS_Data.LieuNaissance = ins_data.INS_Data.LieuNaissance;
    }

    if (ins_data.INS_Data !== undefined && ins_data.profession === undefined || ins_data.profession === null || ins_data.profession === "null" || ins_data.profession === "") {
        ret.profession = "";
    }
    else {
        ret.profession = ins_data.profession;
    }

    if (ins_data.INS_Data !== undefined && ins_data.category === undefined || ins_data.category === null || ins_data.category === "null" || ins_data.category === "") {
        ret.category = "";
    }
    else {
        ret.category = ins_data.category;
    }

    if (ins_data.INS_Data !== undefined && ins_data.mssantemail === undefined || ins_data.mssantemail === null || ins_data.mssantemail === "null" || ins_data.mssantemail === "") {
        ret.mssantemail = ins_data.mssantemail;
    }

    return (ret);
}

const format_fhir_response_from_datatype = (datatype, part_data) => {
    let ret = {
        code: '',
        display: '',
        system: 'http://loinc.org'
    }
    switch (datatype) {
        case "pain":
            ret.code= '72514-3'
            ret.display= "Pain severity"
            break
        case "health_form":
            ret.code= '45698-1'
            ret.display= "Health form"
            break
        case "picture":
            ret.code= '72170-4'
            ret.display= "Picture"
            break
        case "respiratory_rate":
            ret.code= '9279-1'
            ret.display= "Respiratory system"
            break
        case "respiratory_leak":
            ret.code= '33456-5'
            ret.display= "Respiratory leak"
            break
        case "oxigen_flow_rate":
            ret.code= '3151-8'
            ret.display= "Inhaled O2 flow rate"
            break
        case "oxigen_saturation":
            ret.code= '2708-6'
            ret.display= "oxigen saturation"
            break
        case "niv_schedule":
            ret.code= '69988-4'
            ret.display= "NIV usage"
            break
        case "oxi_schedule":
            ret.code= 'LP75328-2'
            ret.display= "oxigen usage"
            break
    }
    return ret
}

const get_reminder_from_type = (reminder_list, type) => {
    let ret = false
    if (reminder_list !== undefined) {        
    reminder_list.forEach((reminder) => {
        if (reminder.alert_type === type) {
            ret = reminder
        }
    })
    }
    return ret
}

const deviceTypeToReminderType = (device_type) => {
    let ret;

    switch (device_type) {
        case "Tucky":
            ret = "tucky_reminder"
            break
        case "Oximeter":
        case "FS20F":
            ret = "oximeter_reminder"
            break
        case "Tensiometer":
        case "BP2A":
        case "BPB6":
            ret = "tensiometer_reminder"
            break
        case "Scale":
        case "LESCALE":
        case "S5":
            ret = "scale_reminder"
            break
        case "healthform_eq5d":
        case "healthform_EQ5D":
            ret = "healthform_eq5d_reminder"
            break
        case "healthform_sf36":
        case "healthform_SF36":
            ret = "healthform_sf36_reminder"
            break
        case "healthform_mdasi":
        case "healthform_MDASI":
            ret = "healthform_mdasi_reminder"
            break
        case "healthform_alimentation":
        case "healthform_ALIMENTATION":
            ret = "healthform_alimentation_reminder"
            break
        case "niv":
            ret = "niv_reminder"
            break
        case "oxigen_therapy":
            ret = "oxi_reminder"
            break
    }

    return ret;
}

const fillNewReminderHours = () => {
    let ret = [
            {value:"--:--", type:"tucky_reminder"},
            {value:"--:--", type:"oximeter_reminder"},
            {value:"--:--", type:"tensiometer_reminder"},
            {value:"--:--", type:"scale_reminder"},
        ]

    return (ret)
}

const convertTextToFormattedMessageIdError = (text) => {
    switch (text) {
        case "Invalid alert phone number":
            return ({id:"message.error.wrongPhoneNumberThreshold", defaultMessage:"Error: Wrong threshold phone number(s)"})
            break
        case "Invalid reminder phone number":
            return ({id:"message.error.wrongPhoneNumberReminder", defaultMessage:"Error: Wrong reminder phone number(s)"})
            break
        case "Wrong hour format":
            return ({id:"message.error.wrongHourFormat", defaultMessage:"Error: Wrong hour(s) format"})
            break
        case "Not enough margin between two reminder hours":
            return ({id:"message.error.notEnoughMarginHours", defaultMessage:"Error: Not enough margin between two reminder hours"})
            break
        case "Can't update device/gateway : gateway has already 4 devices associated":
            return ({id:"message.error.gateway.tooManyDevices", defaultMessage:"Error: Gateway already have too many devices"})
            break
        case "No subscription available":
            return ({id:"account.subscriptionErrorExceedBlock", defaultMessage:"Error: your subscription does not allow additional monitoring"})
            break
        default:
            return ({id:"message.error.default", defaultMessage:"Oups, did not work..."})
            break
    }
}

const convertTextToFormattedMessageIdUnits = (text) => {
    switch (text) {
        case "fever_alert":
            return ({id:"units.celsius", defaultMessage:"°C"})
            break
        case "PR_alert":
        case "bloodpressure_PR_alert":
            return ({id:"units.bpm", defaultMessage:"bpm"})
            break
        case "SPO2_alert":
            return ({id:"units.percent", defaultMessage:"%"})
            break
        case "bloodpressure_sys_high_alert":
        case "bloodpressure_dia_alert":
            return ({id:"units.bpm", defaultMessage:"mmHg"})
            break
        case "weight_alert":
            return ({id:"units.bpm", defaultMessage:"kg"})
            break
        case "breathing_rate_alert":
            return ({id:"units.cycledperminutes", defaultMessage:"cycle/min"})
            break
        case "breathing_oxigen_rate_alert":
        case "breathing_oxygen_rate_alert":
        case "breathing_leakage_alert":
        case "breathing_leakage95_alert":
            return ({id:"units.literperminutes", defaultMessage:"l/min"})
            break
        case "breathing_ahi_alert":
            return ({id:"units.perhour", defaultMessage:"/h"})
            break
        case "breathing_observance_alert":
            return ({id:"units.hoursperday", defaultMessage:"h/day"})
            break
        default:
            return ({id:" ", defaultMessage:""})
            break
    }
}

const formatDataDisplay = (type, value) => {
    let new_value
    if (value !== '-') {
        switch (type) {
            case "fever_alert":
                new_value = value.toFixed(1) + ' °'
                break
            case "PR_alert":
            case "bloodpressure_PR_alert":
                new_value = value + ' bpm'
                break
            case "SPO2_alert":
                new_value = value + ' %'
                break
            case "bloodpressure_sys_high_alert":
            case "bloodpressure_dia_alert":
                new_value = value + ' mmHg'
                break
            case "weight_alert":
                new_value = value + ' kg'
                break
            case "breathing_rate_alert":
                new_value = value + ' cycle/min'
                break
            case "breathing_oxigen_rate_alert":
            case "breathing_leakage_alert":
                new_value = value + ' l/min'
                break
            case "breathing_observance_alert":
                if (typeof(value) === "string") {
                    value = parseFloat(value)
                }
                value = value.toFixed(2)
                var hours = ((value + "").split(".")[0]);
                var mins = ((value + "").split(".")[1]);
                mins = mins / 100 * 60
                mins = mins.toFixed(0)
                if (mins.toString().length === 1) {
                    mins = "0" + mins;
                }
                new_value = hours + "h" + mins
                break
            case "SF36":
            case "Alimentation":
                if (value === '-') {
                    new_value = "false"
                }
                else {
                    new_value = "true"
                }
                break
            case "MDASI":
                if (value === '-') {
                    new_value = "false"
                }
                else {
                    let corrected_value = JSON.parse(value)
                    let final_value = 0
                    corrected_value.forEach(v => {
                        if (v.value > final_value) {
                            final_value = v.value
                        }
                    })
                    new_value = final_value
                }
                break
            case "state":
                if(value === 1){
                    new_value = 
                        <img
                            src={stand}
                            style={{ height: 50, maxHeight: "55px", width: "auto", paddingTop:0 }}
                            alt="position-stand"  
                        />
                }

                //Position supine decubitus (Back)
                else if(value === 2){
                    new_value = 
                        <img
                            src={back}
                            style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "70%", paddingTop:15 }}
                            alt="position-back"     
                        />
                }

                //Position prone decubitus (belly)
                else if(value === 3){
                    new_value = 
                        <img
                            src={belly}
                            style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "70%", paddingTop:15 }}
                            alt="position-belly"  
                        />
                }

                //Position right lateral decubitus (right side)
                else if(value === 4){
                    new_value = 
                        <img
                            src={rightSide}
                            style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "60%", paddingTop:15 }}
                            alt="position-righ-side" 
                        />
                }

                //Position left lateral decubitus (left side)
                else if(value === 5){
                    new_value = 
                        <img
                            src={leftSide}
                            style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "60%", paddingTop:15 }}
                            alt="position-left-side" 
                        />
                }

                //Upside down position
                else if(value === 6){
                    new_value = 
                        <img
                            src={upsideDown}
                            style={{ height: 50, maxHeight: "55px", width: "auto", paddingTop:0 }}
                            alt="position-upside-down"  
                        />
                }

                //Display "NC" if position is not defined
                else{
                    return(null);
                }
                break
            default:
                new_value = value
                break
        }
    }
    else {
        new_value = '-'
    }
    return (new_value)
}

const getFirstDevice = (features) => {
    let devices = [
        "niv", //b20
        "oxi", //b21
        "thermometer", //b0
        "oximeter", //b1
        "tensiometer", //b2
        "scale", //b3
        "pain", //b4
        "healthform_EQ5D", //b5
        "healthform_SF36", //b15
        "healthform_MDASI", //b16
        "healthform_ALIMENTATION", //b17
        "picture", //b19
    ]
    for (let i = 0; i < devices.length; i++) {
        if (devices[i] !== "" && checkBit(features, featureToBitNumber(devices[i])) === true) {
            // Return the tab ID matching the feature
            switch (devices[i]) {
                case "thermometer": return "1";
                case "oximeter": return "2";
                case "tensiometer": return "3";
                case "scale": return "4";
                case "pain": return "5";
                case "healthform_EQ5D": return "6";
                case "healthform_SF36": return "16";
                case "healthform_MDASI": return "17";
                case "healthform_ALIMENTATION": return "18";
                case "picture": return "20";
                case "niv": return "21";
                case "oxi": return "22";
                default: return "1";
            }
        }
    }
    return "1";
}

// Tells whether a given parameter actually holds measurement data for a patient.
// Used to pick the default tab on the first that carries data (see getFirstTabWithData).
const hasTabData = (patientData, device) => {
    if (patientData === undefined || patientData === null) {
        return false;
    }
    const len = (arr) => Array.isArray(arr) && arr.length > 0;
    switch (device) {
        case "thermometer":             return len(patientData.thermometer);
        case "oximeter":                return patientData.pulseOximeter !== undefined && (len(patientData.pulseOximeter.pulseRate) || len(patientData.pulseOximeter.sp02));
        case "tensiometer":             return patientData.pulseTensiometer !== undefined && (len(patientData.pulseTensiometer.systolic) || len(patientData.pulseTensiometer.pulseRate));
        case "scale":                   return patientData.scale_data !== undefined && len(patientData.scale_data.weight);
        case "pain":                    return len(patientData.pain);
        case "healthform_EQ5D":         return patientData.eq5d !== undefined && (len(patientData.eq5d.form_res) || len(patientData.eq5d.healthscale));
        case "healthform_SF36":         return patientData.sf36 !== undefined && len(patientData.sf36.form_res);
        case "healthform_MDASI":        return patientData.mdasi !== undefined && len(patientData.mdasi.form_res);
        case "healthform_ALIMENTATION": return patientData.alimentation !== undefined && len(patientData.alimentation.form_res);
        case "picture":                 return len(patientData.photo);
        case "kidney_failure":          return len(patientData.kidney_device) || len(patientData.kidney_blood);
        case "niv":                     return patientData.breathing !== undefined && (len(patientData.breathing.respiratory_rate) || len(patientData.breathing.niv_usage) || len(patientData.breathing.respiratory_leak));
        case "oxigen_therapy":          return patientData.breathing !== undefined && (len(patientData.breathing.oxygen_flow_rate) || len(patientData.breathing.oxi_usage));
        default:                        return false;
    }
}

// Returns the tab id of the first enabled parameter (in tab display order, so temperature
// first) that actually carries data. When no enabled parameter carries data yet, falls back
// to the first enabled tab in that same order (temperature when it is enabled).
const getFirstTabWithData = (features, patientData) => {
    // Must match the tab order rendered in PatientBox.display_birthplace_tabs
    const tabs = [
        { device: "thermometer",             id: "1"  },
        { device: "oximeter",                id: "2"  },
        { device: "tensiometer",             id: "3"  },
        { device: "scale",                   id: "4"  },
        { device: "pain",                    id: "5"  },
        { device: "healthform_EQ5D",         id: "6"  },
        { device: "healthform_SF36",         id: "16" },
        { device: "healthform_MDASI",        id: "17" },
        { device: "healthform_ALIMENTATION", id: "18" },
        { device: "picture",                 id: "20" },
        { device: "kidney_failure",          id: "23" },
        { device: "niv",                     id: "21" },
        { device: "oxigen_therapy",          id: "22" },
    ];
    const enabledTabs = tabs.filter((tab) => checkBit(features, featureToBitNumber(tab.device)));
    // First enabled tab carrying data (temperature first, then the next one that has data).
    const tabWithData = enabledTabs.find((tab) => hasTabData(patientData, tab.device));
    if (tabWithData !== undefined) {
        return tabWithData.id;
    }
    // Nothing carries data yet: keep the first enabled tab so we still land on temperature.
    return enabledTabs.length > 0 ? enabledTabs[0].id : "1";
}

const FEATURE_NAMES = [
    "thermometer", //b0
    "oximeter", //b1
    "tensiometer", //b2
    "scale", //b3
    "pain", //b4
    "healthform_EQ5D", //b5
    "reminder", //b6
    "sms", //b7
    "mail", //b8
    "http", //b9
    "threshold2", //b10
    "patient_template", //b11
    "multi_recipient", //b12
    "ins", //b13
    "hepadom", //b14
    "healthform_SF36", //b15
    "healthform_MDASI", //b16
    "healthform_ALIMENTATION", //b17
    "recall_alert", //b18
    "picture", //b19
    "niv", //b20
    "oxigen_therapy", //b21
    "patient_add_delete_block", //b22
    "kidney_failure", //b23
    "configBleGateways", //b24
    "concerned_speciality_and_delegation", //b25
]

const featureToBitNumber = (feature) => {
    let i = 0;
    let ret = false;
    while (FEATURE_NAMES[i] && ret === false) {
        if (feature === FEATURE_NAMES[i]) {
            ret = i;
        }
        i++;
    }
    return ret
}

const checkBit = (number, bit) => {
    let ret = false
    if ((number & (1 << bit)) > 0) {
        ret = true;
    }
    return ret
}

const cleanSmsList = (list) => {
    let i = 0;
    let ret = []
    if (list !== undefined && list !== null) {
    while (i < list.length) {
        if (list[i] !== '' && isValidPhoneNumber(list[i])) {
            ret.push(list[i])
        }
        i++;
        }
    }
    if (ret.length === 0) {
        ret = ['']
    }
    return ret
}

const contactListsToMultiRecipient = (notif_list, reminder_list, notif_list_night, reminder_list_night) => {
    let contact_list = []
    if (notif_list !== null || reminder_list !== [''] || reminder_list !== '') {
        let contact_list_threshold
        if (typeof(notif_list) === "string") {
            contact_list_threshold = notif_list.split(',')
        }
        else {
            contact_list_threshold = notif_list
        }
        contact_list_threshold.forEach((value, index) => {
            if (value !== '') {
            contact_list.push({index: index, value: value, threshold: true, reminder: false, day_time: "day"})
            }
        })
    }
    if (reminder_list !== null && reminder_list !== [''] && reminder_list !== '') { 
        let contact_list_reminder
        if (typeof(reminder_list) === "string") {
            contact_list_reminder = reminder_list.split(',')
        }
        else {
            contact_list_reminder = reminder_list
        }
        contact_list_reminder.forEach((new_value, index) => {
            let find_mail = contact_list.find(({value}) => value === new_value)
            if (find_mail === undefined) {
                contact_list.push({index: index, value: new_value, threshold: false, reminder: true, day_time: "day"})
            }
            else {
                let index = contact_list.findIndex(((contact) => contact.value === new_value))
                let contact = contact_list[index]
                contact.reminder = true
                contact_list[index] = contact
            }
        })
    }
    if (notif_list_night !== null || notif_list_night !== [''] || notif_list_night !== '') { 
        let contact_list_notif_night
        if (typeof(notif_list_night) === "string") {
            contact_list_notif_night = notif_list_night.split(',')
        }
        else {
            contact_list_notif_night = notif_list_night
        }
        contact_list_notif_night.forEach((new_value, index) => {
            let find_mail = contact_list.find(({value}) => value === new_value)
            if (find_mail === undefined) {
                if (new_value !== '') {
                contact_list.push({index: index, value: new_value, threshold: true, reminder: false, day_time: "night"})
            }
            }
            else {
                let index = contact_list.findIndex(((contact) => contact.value === new_value))
                let contact = {...contact_list[index]}
                contact.day_time = "night"
                contact_list.push(contact)
            }
        })
    }
    if (reminder_list_night !== null && reminder_list_night !== [''] && reminder_list_night !== '') { 
        let contact_list_reminder_night
        if (typeof(reminder_list_night) === "string") {
            contact_list_reminder_night = reminder_list_night.split(',')
        }
        else {
            contact_list_reminder_night = reminder_list_night
        }
        contact_list_reminder_night.forEach((new_value, index) => {
            let find_mail = contact_list.find(({value}) => value === new_value)
            if (find_mail === undefined) {
                contact_list.push({index: index, value: new_value, threshold: false, reminder: true, day_time: "night"})
            }
            else {
                let index = contact_list.findIndex(((contact) => contact.value === new_value))
                let contact = contact_list[index]
                contact.reminder = true
                contact_list[index] = contact
            }
        })
    }
    if (contact_list.length === 0) {
        contact_list.push({index: 0, value: "", threshold: true, reminder: false, day_time: "day"})
    }
    contact_list.sort((a,b) => (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0)) //order contact by alphabetical order
    return (contact_list)
}

const makeAverage = (data, number_list, decimals) => {
    let i = 0;
    let average = 0
    while (data[i] !== undefined) {
        if (number_list.indexOf(i) !== -1) {
            average += data[i]
        }
        i++;
    }
    average = average / number_list.length
    if (decimals !== undefined) {
        average = parseFloat(average.toFixed(decimals))
    }
    return average
}

const dateToMidnight = (date) => {
    //get the datetime of the data
    let convertedDate = new Date(date)
    //set to midnight
    convertedDate.setHours(0)
    convertedDate.setMinutes(0)
    convertedDate.setSeconds(0)
    convertedDate.setMilliseconds(0)

    return convertedDate
}

const testAnyModuleUsed = (module_list) => {
    let ret = false;
    let x = 0;
    while (ret === false && module_list[x]) {
        ret = module_list[x].used
        x++;
    }
    return ret
}

const testModuleInListUsed = (module_list, valid_list) => {
    let ret = false;
    let x = 0;
    while (ret === false && module_list[x]) {
        if ((valid_list.findIndex((e) => e === module_list[x].name)) !== -1) {
            ret = module_list[x].used
        }
        x++;
    }
    return ret
}

const testAnyModuleUsedExcept = (module_list, exception_list) => {
    let ret = false;
    let x = 0;
    while (ret === false && module_list[x]) {
        if ((exception_list.findIndex((e) => e === module_list[x].name)) === -1) {
            ret = module_list[x].used
        }
        x++;
    }
    return ret
}

const testSmartphoneDisplay = (module_list) => {
    let ret = false
    let module_smartphone_tucky = module_list.find((m) => m.name === "tucky_smartphone")
    if (module_smartphone_tucky !== undefined && module_smartphone_tucky.used === true) {
        ret = true
    }
    return ret
}

const testNivData = (data) => {
    if (data.niv_schedule.length > 0
     || data.niv_usage.length > 0
     || data.respiratory_rate.length > 0
     || data.respiratory_leak.length > 0
     || (data.respiratory_ahi !== undefined && data.respiratory_ahi.length > 0)
     || (data.respiratory_leak95 !== undefined && data.respiratory_leak95.length > 0)) {
        return true
    }
    return false
}

const testOxiData = (data) => {
    if (data.oxi_schedule.length > 0
     || data.oxi_usage.length > 0
     || data.oxygen_flow_rate.length > 0) {
        return true
    }
    return false
}

const dataAlertColorParamsFromType = (type) => {
    let params = {
        OrangeShift: 0,
        supinf: "sup"
    }
    switch (type) {
        case "MDASI":
            params.OrangeShift = 0
            break
        case "NIVUsage":
            params.supinf = "inf"
            params.OrangeShift = 0
            break
        case "EQ5D":
            params.supinf = "inf"
            params.OrangeShift = 0.1
            break
        case "tuckyTemperature":
            params.OrangeShift = 1
            break
        case "oximeterPulseRate":
        case "pain":
            params.OrangeShift = 2
            break
        case "oximeterSPO2":
            params.supinf = "inf"
            params.OrangeShift = 2
            break
        case "OxiRate":
            params.supinf = "sup"
            params.OrangeShift = 1
            break
        case "tensiometerPulseRate":
        case "tensiometerBloodpressure":
        case "scaleWeight":
        case "NIVLeak":
            params.OrangeShift = 10
            break
        case "NIVRate":
            params.supinf = "sup"
            params.OrangeShift = 10
            break
        case "EQ5DHealthscale":
            params.supinf = "inf"
            params.OrangeShift = 20
            break
    }
    return params
}

const dataAlertColor = (dataset, type, threshold, threshold2) => {
    let color= "#767676"

    let dataAlertColorParams = dataAlertColorParamsFromType(type);
    if(dataset !== undefined){
        let threshold2_type = ""
        switch (type) {
            case "tuckyTemperature":
                threshold2_type = "temperature"
                break
            case "oximeterPulseRate":
            case "tensiometerPulseRate":
                threshold2_type = "pulse_rate"
                break
            case "oximeterSPO2":
                threshold2_type = "spo2"
                break
            case "scaleWeight":
                threshold2_type = "scale"
                break
            case "tensiometerBloodpressure":
                dataset = dataset.split('/')[0]
                threshold2_type = "tension"
                break
            case "MDASI":
                if (dataset !== '-') {
                    let corrected_value = JSON.parse(dataset)
                    let final_value = 0
                    corrected_value.forEach(v => {
                        if (v.value > final_value) {
                            final_value = v.value
                        }
                    })
                    dataset = final_value
                }
                threshold2_type = "MDASI"
                break
            case "oximeterSPO2":
                threshold2_type = "spo2"
                break
            case "NIVRate":
            case "OxiRate":
                threshold2_type = "breathing_rate"
                break
            case "NIVLeak":
                threshold2_type = "breathing_leak"
                break
            case "NIVUsage":
                if(dataset === "-"){
                    return ('#767676');
                }
                else {
                    return ('#2896E5');                    
                }
                break
            default:
                threshold2_type = type
                break
        }
        //Set val color
        if (threshold2 === null || threshold2 === undefined) {
            threshold2 = setDefaultThreshold2(threshold2_type)
        }
        color = setMeasureColor(dataset, threshold, dataAlertColorParams.OrangeShift, dataAlertColorParams.supinf, threshold2);
    }

    return (color);
}

const getFHIRCodesFromFeatures = (features) => {
    let code_list = ""
    if (features === undefined || checkBit(features, Utils.featureToBitNumber("thermometer"))) {
        code_list += "8310-5,8418512.6,72282-7,"
    }
    if (checkBit(features, Utils.featureToBitNumber("oximeter")) || checkBit(features, Utils.featureToBitNumber("oxigen_therapy"))) {
        code_list += "2708-6,8867-4,"
    }
    if (checkBit(features, Utils.featureToBitNumber("tensiometer"))) {
        code_list += "8460-6,8867-4,"
    }
    if (checkBit(features, Utils.featureToBitNumber("scale"))) {
        code_list += "29463-7,"
    }
    if (checkBit(features, Utils.featureToBitNumber("pain"))) {
        code_list += "72514-3,"
    }
    if (checkBit(features, Utils.featureToBitNumber("picture"))) {
        code_list += "72170-4,"
    }
    if (checkBit(features, Utils.featureToBitNumber("healthform_EQ5D"))
        || checkBit(features, Utils.featureToBitNumber("healthform_SF36"))
        || checkBit(features, Utils.featureToBitNumber("healthform_MDASI"))
        || checkBit(features, Utils.featureToBitNumber("healthform_ALIMENTATION"))
        ) {
        code_list += "45698-1,"
    }
    if ((checkBit(features, Utils.featureToBitNumber("niv")))
     || (checkBit(features, Utils.featureToBitNumber("oxigen_therapy")))) {
        code_list += "2708-6,9279-1,33456-5,3151-8,69988-4,LP75328-2,90562-0,33456-95,"
    }
    if (code_list !== ""){
        code_list = code_list.slice(0, -1);
    }
    return code_list
}

//Function to filter the data, from all to a specific type
const filterData = (allData, type) => {
    let ret = allData.filter(obj => {return obj.type === type})
    return (ret)
}

const filterScaleData = (allData) => {
    let ret = []
    allData.forEach(data => {
        if (data.value.includes("T5W") === false) {
            ret.push(data)
        }
    })
    return ret
}

//Function to filter the healthform by type
const filterHealthform = (allData, type) => {
    let ret = []
    allData.forEach(data => {
        let value = JSON.parse(data.value)
        let label = value.findIndex((val) => val.label === "form_type")
        if (value[label].value === type) {
            ret.push(data)
        }
    })
    return (ret)
}

const mergeBasicOldData = (old_data, new_data) => {
    if (old_data !== undefined){
        if (old_data.length > 0){
            for (var j = 0; j < old_data.length; j++){
                new_data.push(old_data[j])
            }
        }
    }
}

const mergeBasicNewData = (current_data, new_data, type) => {
    let isANewDateValue = "";
    if(new_data.length !== 0){
        for (var i = new_data.length-1; i >= 0; i--){        // Find new values and add it
            isANewDateValue = current_data.find(xDate => { return xDate.x === new Date(new_data[i].eventDate).getTime() })
            if(isANewDateValue === undefined){
                current_data.push({x: new Date(new_data[i].eventDate).getTime(), y: new_data[i].value})
            }
        }
    }
}

const testIsDevicesAndGatewayAssociate = (devices) => {
    let ret
    ret = (devices.device1.id !== "dissociate" || devices.device2.id !== "dissociate" || devices.device3.id !== "dissociate" || devices.device4.id !== "dissociate")
    return ret
}

const testIsAnyDeviceAssociate = (devices) => {
    let ret
    ret = (devices.device1.id !== "dissociate" || devices.device2.id !== "dissociate" || devices.device3.id !== "dissociate" || devices.device4.id !== "dissociate")
    return ret
}

const display_temperatureGraph = (props, new_window, popupNum) => {
    return(
        <GraphOneCurve
            style={{display: "flex", height: "100%", width: "100%", justifyContent:'center', alignItems:'center'}}
            new_window =        {new_window}
            onEnlarge =         {props.onEnlarge}
            id_graph =          {props.profileData.Patient_Data.id_patient + (popupNum || 0)}
            curve_name =        {props.intl.formatMessage({id: "patientConstants.temperature"})}
            min_x =             {new Date(props.dateSelected[0]).getTime()}
            max_x =             {new Date(props.dateSelected[1]).getTime()}
            curve =             {props.profileData.Patient_Data.thermometer}
            curve_color =       {'#2896E5'}
            threshold_name =    {props.intl.formatMessage({id: "graph.threshold.fever", defaultMessage: "Alerte fièvre"})}
            threshold =         {props.profileData.Patient_Data.MaxFeverDrawing}
            threshold_color =   {'#2896E5'}
            pointColorZones =   {{ red: '#DB2828', orange: '#F2711C', green: '#21BA45' }}
            pointOrangeShift =  {1}
            y_axis_title =      {props.intl.formatMessage({id: "patientConstants.temperature"})+ ' (' + props.intl.formatMessage({id: "patientConstants.temperatureUnit"}) + ')'}            
            min =               {32}
            max =               {42}
            currentTime =       {props.profileData.Patient_Data.currentTime}
            pointRadius =       {props.pointRadius}
        />
    )
}

const display_pulseOximeterGraph = (props, num, new_window) => {
    return(
        <GraphTwoCurves
            style={{display: "flex", height: "100%", width: "100%", justifyContent:'center', alignItems:'center'}}
            new_window =        {new_window}
            onEnlarge =         {props.onEnlarge}
            id_graph =          {props.profileData.Patient_Data.id_patient + num}
            curve1_name =       {props.intl.formatMessage({id: "patientConstants.heartRate"})}
            min_x =             {new Date(props.dateSelected[0]).getTime()}
            max_x =             {new Date(props.dateSelected[1]).getTime()}
            curve1 =            {props.profileData.Patient_Data.pulseOximeter.pulseRate}
            curve1_color =      {'#2896E5'}
            threshold1_name =   {props.intl.formatMessage({id: "graph.threshold.heartRate", defaultMessage: "Alerte FC"})}
            threshold1 =        {props.profileData.Patient_Data.MaxPulseRateDrawing}
            threshold1_color =  {'#2896E5'}
            y_axis_title1 =     {props.intl.formatMessage({id: "patientConstants.heartRate"})+ ' (' + props.intl.formatMessage({id: "patientConstants.heartRateUnit"}) + ')'}
            min1 =              {40}
            max1 =              {200}
            curve2_name =       {props.intl.formatMessage({id: "patientConstants.spo2"})}
            curve2 =            {props.profileData.Patient_Data.pulseOximeter.sp02}
            curve2_color =      {'#e5ac28'}
            threshold2_name =   {props.intl.formatMessage({id: "graph.threshold.spo2", defaultMessage: "Alerte SpO2"})}
            threshold2 =        {props.profileData.Patient_Data.MinSpO2Drawing}
            threshold2_color =  {'#e5ac28'}
            min2 =              {80}
            max2 =              {100}
            y_axis_title2 =     {props.intl.formatMessage({id: "patientConstants.spo2"})+ ' (' + props.intl.formatMessage({id: "patientConstants.spo2Unit"}) + ')'}
            currentTime =       {props.profileData.Patient_Data.currentTime}
            pointRadius =       {props.pointRadius}
        />
    )
}

const display_tensiometerGraph = (props, new_window, num) => {
    let alertPointReminder = AlertManager.getLastAlertMax7days(props.profileData.Patient_Data.alerts_triggered, "reminder_alert")
    return(
        <GraphThreeCurves
            style={{display: "flex", height: "100%", width: "100%", justifyContent:'center', alignItems:'center'}}
            new_window =        {new_window}
            onEnlarge =         {props.onEnlarge}
            id_graph =          {props.profileData.Patient_Data.id_patient + (num ? num : 2) }
            curve1_name =       {props.intl.formatMessage({id: "patientConstants.heartRate"})}
            min_x =             {new Date(props.dateSelected[0]).getTime()}
            max_x =             {new Date(props.dateSelected[1]).getTime()}
            curve1 =            {props.profileData.Patient_Data.pulseTensiometer.pulseRate}
            curve1_color =      {'#2896E5'}
            threshold1_name =   {props.intl.formatMessage({id: "graph.threshold.heartRate", defaultMessage: "Alerte FC"})}
            threshold1 =        {props.profileData.Patient_Data.MaxPulseRateDrawingTension}
            threshold1_color =  {'#2896E5'}
            y_axis_title1 =     {props.intl.formatMessage({id: "patientConstants.heartRate"})+ ' (' + props.intl.formatMessage({id: "patientConstants.heartRateUnit"}) + ')'}
            min1 =              {40}
            max1 =              {200}
            curve2_name =       {props.intl.formatMessage({id: "patientConstants.pressureSystolic"})}
            curve2 =            {props.profileData.Patient_Data.pulseTensiometer.systolic}
            curve2_color =      {'#e5ac28'}
            threshold2_name =   {props.intl.formatMessage({id: "graph.threshold.systolic", defaultMessage: "Alerte tension systolique"})}
            threshold2 =        {props.profileData.Patient_Data.MaxSystolicDrawingTension}
            threshold2_color =  {'#e5ac28'}
            y_axis_title2 =     {props.intl.formatMessage({id: "patientConstants.pressureBlood"})+ ' (' + props.intl.formatMessage({id: "patientConstants.pressureUnit"}) + ')'}
            min2 =              {40}
            max2 =              {200}
            curve3_name =       {props.intl.formatMessage({id: "patientConstants.pressureDiastolic"})}
            curve3 =            {props.profileData.Patient_Data.pulseTensiometer.diastolic}
            curve3_color =      {'#e2d1aa'}
            threshold3_name =   {props.intl.formatMessage({id: "graph.threshold.diastolic", defaultMessage: "Alerte tension diastolique"})}
            threshold3 =        {props.profileData.Patient_Data.MaxDiastolicDrawingTension}
            threshold3_color =  {'#e2d1aa'}
            min3 =              {40}
            max3 =              {200}
            currentTime =       {props.profileData.Patient_Data.currentTime}
            pointRadius =       {props.pointRadius}
            alertPointsReminder = {alertPointReminder}
            connectCurve2Curve3 = {true}
        />
    )
}

const display_scaleGraph = (props, new_window, num) => {
    return(
        <GraphOneCurve
            style={{display: "flex", height: "100%", width: "100%", justifyContent:'center', alignItems:'center'}}
            new_window =        {new_window}
            onEnlarge =         {props.onEnlarge}
            id_graph =          {props.profileData.Patient_Data.id_patient + (num ? num : 3)}
            curve_name =        {props.intl.formatMessage({id: "patientConstants.weight"})}
            min_x =             {new Date(props.dateSelected[0]).getTime()}
            max_x =             {new Date(props.dateSelected[1]).getTime()}
            curve =             {props.profileData.Patient_Data.scale_data.weight}
            curve_color =       {'#2896E5'}
            threshold_name =    {props.intl.formatMessage({id: "graph.threshold.weight", defaultMessage: "Alerte poids"})}
            threshold =         {props.profileData.Patient_Data.weightThreshold}
            threshold_color =   {'#2896E5'}
            y_axis_title =      {props.intl.formatMessage({id: "patientConstants.weight"})+ ' (' + props.intl.formatMessage({id: "patientConstants.weightUnit"}) + ')'}            
            min =               {20}
            max =               {120}
            currentTime =       {props.profileData.Patient_Data.currentTime}
            pointRadius =       {props.pointRadius}
        />
    )
}

const display_painGraph = (props, new_window, popupNum) => {
    return(
        <GraphOneCurve
            style={{display: "flex", height: "100%", width: "100%", justifyContent:'center', alignItems:'center'}}
            new_window =        {new_window}
            onEnlarge =         {props.onEnlarge}
            id_graph =          {props.profileData.Patient_Data.id_patient + (popupNum || 4)}
            curve_name =        {props.intl.formatMessage({id: "patientConstants.pain"})}
            min_x =             {new Date(props.dateSelected[0]).getTime()}
            max_x =             {new Date(props.dateSelected[1]).getTime()}
            curve =             {props.profileData.Patient_Data.pain}
            curve_color =       {'#2896E5'}
            threshold_name =    {props.intl.formatMessage({id: "graph.threshold.pain", defaultMessage: "Alerte douleur"})}
            threshold =         {props.profileData.Patient_Data.MaxPainDrawing}
            threshold_color =   {'#2896E5'}
            y_axis_title =      {props.intl.formatMessage({id: "patientConstants.pain"})}                        
            min =               {0}
            max =               {10}
            currentTime =       {props.profileData.Patient_Data.currentTime}
            pointRadius =       {props.pointRadius}
        />
    )
}

const display_formSF36GraphColumns = (column, hours_number) => {
    return (
        <tr>
            {column.map((c, i) => {
                return (
                    <td><b>{c}</b></td>
                )
            })}
        </tr>
    )
}

const display_formAlimentationGraphColumns = (column, hours_number, size) => {
    if (column.length > size) {
        return (
            <tr>
                {column.map((c, i) => {
                    return (
                        <td>{c}</td>
                    )
                })}
            </tr>
        )
    }
    else {
        return (
            <tr>
                <th colSpan={hours_number}>{column[0]}</th>
            </tr>
        )
    }
}

const display_formEQ5DGraph = (props, new_window, popupNum) => {
        return(
            <GraphTwoCurves
            style={{display: "flex", height: "100%", width: "100%", justifyContent:'center', alignItems:'center'}}
            new_window =        {new_window}
                onEnlarge =          {props.onEnlarge}
                id_graph =           {props.profileData.Patient_Data.id_patient + (popupNum || 5)}
                curve1_name =        {props.intl.formatMessage({id: "patientConstants.healthLevel"})}
                min_x =              {new Date(props.dateSelected[0]).getTime()}
                max_x =              {new Date(props.dateSelected[1]).getTime()}
                curve1 =             {props.profileData.Patient_Data.eq5d.form_res}
                curve1_color =       {'#2896E5'}
                threshold1_name =    {props.intl.formatMessage({id: "graph.threshold.health", defaultMessage: "Alerte santé"})}
                threshold1 =         {props.profileData.Patient_Data.MaxHealthformDrawing}
                threshold1_color =   {'#2896E5'}
                y_axis_title1 =      {props.intl.formatMessage({id: "patientConstants.healthLevel"})}
                min1 =               {0}
                max1 =               {1}
                curve2_name =        {props.intl.formatMessage({id: "patientConstants.healthScale"})}
                curve2 =             {props.profileData.Patient_Data.eq5d.healthscale}
                curve2_color =       {'#e5ac28'}
                threshold2_name =    {''}
                threshold2 =         {props.profileData.Patient_Data.MaxHealthscaleDrawing}
                threshold2_color =   {'#e5ac28'}
                min2 =               {0}
                max2 =               {100}
                y_axis_title2 =      {props.intl.formatMessage({id: "patientConstants.healthScale"})}                
                currentTime =        {props.profileData.Patient_Data.currentTime}
            /> 
        )
}

const display_SF36Graph = (props, new_window) => {
    let columns_hours = [""]
    let multiple_dates = false
    let registered_by = <FormattedMessage id="form.unknown" defaultMessage="Unknown" />
    if (props.profileData.Patient_Data.sf36.form_res.length > 1) {
        let first_date = new Date(props.profileData.Patient_Data.sf36.form_res[0].x)
        let last_date = new Date(props.profileData.Patient_Data.sf36.form_res[props.profileData.Patient_Data.sf36.form_res.length - 1].x)
        if (
            first_date.getDate() !== last_date.getDate()
            || first_date.getMonth() !== last_date.getMonth()
            || first_date.getFullYear() !== last_date.getFullYear()
            ) {
            multiple_dates = true
        }
    }

    if (props.accountInformation.role !== "admin" && props.accountInformation.role !== "staff") {
        props.profileData.Patient_Data.sf36.form_res.forEach(form => {
            let date = new Date(form.x)
            if (multiple_dates) {
                let new_date = date.getDate() + '/'
                if ((date.getMonth() + 1) > 9) {
                    new_date += (date.getMonth() + 1) + '/'
                }
                else {
                    new_date += "0" + (date.getMonth() + 1) + '/'
                }
                new_date += date.getFullYear() + ' '
                new_date += date.toTimeString().split(':')[0] + ":"
                new_date += date.toTimeString().split(':')[1]
                columns_hours.push(new_date)
            }
            else {
                let new_date = ""
                new_date += date.toTimeString().split(':')[0] + ":"
                new_date += date.toTimeString().split(':')[1]
                columns_hours.push(new_date)
            }


            return(
                <table
                  className="table table-striped table-bordered"
                  style={{width:"100%", overflow:"auto", fontSize:"80%"}}
                >
                    <thead>
                        <tr>
                            {columns_hours.map((column) => (
                                <th>{column}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        <tr><td></td><td></td><td></td></tr>
                    </tbody>
                </table>
            )
        })
    }
    else {
        let columns_data = [
            [<FormattedMessage id="sf36.form.one" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.two" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.three" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.three.one" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.three.two" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.three.three" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.three.four" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.three.five" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.three.six" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.three.seven" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.three.eight" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.three.nine" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.three.ten" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.four" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.four.one" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.four.two" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.four.three" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.four.four" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.five" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.five.one" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.five.two" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.five.three" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.six" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.seven" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.eight" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.nine" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.nine.one" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.nine.two" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.nine.three" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.nine.four" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.nine.five" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.nine.six" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.nine.seven" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.nine.eight" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.nine.nine" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.ten" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.eleven" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.eleven.one" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.eleven.two" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.eleven.three" defaultMessage="" />],
            [<FormattedMessage id="sf36.form.eleven.four" defaultMessage="" />],
            [<FormattedMessage id="form.registered_by" defaultMessage="Registered by" />],            
        ]
        const optionsQuestionOne = [
          <FormattedMessage id="sf36.form.option.one.one" defaultMessage=""/>,
          <FormattedMessage id="sf36.form.option.one.two" defaultMessage=""/>,
          <FormattedMessage id="sf36.form.option.one.three" defaultMessage=""/>,
          <FormattedMessage id="sf36.form.option.one.four" defaultMessage=""/>,
          <FormattedMessage id="sf36.form.option.one.five" defaultMessage=""/>,
        ]
        const optionsQuestionTwo = [
          <FormattedMessage id="sf36.form.option.two.one" defaultMessage=""/>,
          <FormattedMessage id="sf36.form.option.two.two" defaultMessage=""/>,
          <FormattedMessage id="sf36.form.option.two.three" defaultMessage=""/>,
          <FormattedMessage id="sf36.form.option.two.four" defaultMessage=""/>,
          <FormattedMessage id="sf36.form.option.two.five" defaultMessage=""/>,
        ]
        const optionsQuestionThree = [
          <FormattedMessage id="sf36.form.option.three.one" defaultMessage=""/>,
          <FormattedMessage id="sf36.form.option.three.two" defaultMessage=""/>,
          <FormattedMessage id="sf36.form.option.three.three" defaultMessage=""/>,
        ]
        const optionsQuestionFour = [
          <FormattedMessage id="sf36.form.option.four.one" defaultMessage=""/>,
          <FormattedMessage id="sf36.form.option.four.two" defaultMessage=""/>,
        ]
        const optionsQuestionSix = [
          <FormattedMessage id="sf36.form.option.six.one" defaultMessage=""/>,
          <FormattedMessage id="sf36.form.option.six.two" defaultMessage=""/>,
          <FormattedMessage id="sf36.form.option.six.three" defaultMessage=""/>,
          <FormattedMessage id="sf36.form.option.six.four" defaultMessage=""/>,
        ]
        const optionsQuestionEight = [
          <FormattedMessage id="sf36.form.option.eight.one" defaultMessage=""/>,
          <FormattedMessage id="sf36.form.option.eight.two" defaultMessage=""/>,
          <FormattedMessage id="sf36.form.option.eight.three" defaultMessage=""/>,
          <FormattedMessage id="sf36.form.option.eight.four" defaultMessage=""/>,
          <FormattedMessage id="sf36.form.option.eight.five" defaultMessage=""/>,
        ]
        const optionsQuestionNine = [
          <FormattedMessage id="sf36.form.option.nine.one" defaultMessage=""/>,
          <FormattedMessage id="sf36.form.option.nine.two" defaultMessage=""/>,
          <FormattedMessage id="sf36.form.option.nine.three" defaultMessage=""/>,
          <FormattedMessage id="sf36.form.option.nine.four" defaultMessage=""/>,
          <FormattedMessage id="sf36.form.option.nine.five" defaultMessage=""/>,
        ]
        const optionsQuestionEleven = [
          <FormattedMessage id="sf36.form.option.eleven.one" defaultMessage=""/>,
          <FormattedMessage id="sf36.form.option.eleven.two" defaultMessage=""/>,
          <FormattedMessage id="sf36.form.option.eleven.three" defaultMessage=""/>,
          <FormattedMessage id="sf36.form.option.eleven.four" defaultMessage=""/>,
          <FormattedMessage id="sf36.form.option.eleven.five" defaultMessage=""/>,
        ]
        const averages = [
          [<FormattedMessage id="sf36.form.average.physical_function" defaultMessage=""/>],
          [<FormattedMessage id="sf36.form.average.physical_limitation" defaultMessage=""/>],
          [<FormattedMessage id="sf36.form.average.emotional_limitation" defaultMessage=""/>],
          [<FormattedMessage id="sf36.form.average.energy" defaultMessage=""/>],
          [<FormattedMessage id="sf36.form.average.well_being" defaultMessage=""/>],
          [<FormattedMessage id="sf36.form.average.social" defaultMessage=""/>],
          [<FormattedMessage id="sf36.form.average.pain" defaultMessage=""/>],
          [<FormattedMessage id="sf36.form.average.general" defaultMessage=""/>],
          [<FormattedMessage id="sf36.form.average.change" defaultMessage=""/>],              
        ]
        const values = [
            [1],
            [2],
            [3],
            [4],
            [5],
            [6],
            [7],
            [8],
            [9],
            [10],
            [11],
            [12],
            [13],
            [14],
            [15],
            [16],
            [17],
            [18],
            [19],
            [20],
            [21],
            [22],
            [23],
            [24],
            [25],
            [26],
            [27],
            [28],
            [29],
            [30],
            [31],
            [32],
            [33],
            [34],
            [35],
            [36]
        ]

        props.profileData.Patient_Data.sf36.form_res.forEach(form => {
            let date = new Date(form.x)
            if (multiple_dates) {
                let new_date = date.getDate() + '/'
                if ((date.getMonth() + 1) > 9) {
                    new_date += (date.getMonth() + 1) + '/'
                }
                else {
                    new_date += "0" + (date.getMonth() + 1) + '/'
                }
                new_date += date.getFullYear() + ' '
                new_date += date.toTimeString().split(':')[0] + ":"
                new_date += date.toTimeString().split(':')[1]
                columns_hours.push(new_date)
            }
            else {
                let new_date = ""
                new_date += date.toTimeString().split(':')[0] + ":"
                new_date += date.toTimeString().split(':')[1]
                columns_hours.push(new_date)
            }
            let data
            if (typeof(form.y) === "string") {
                data = JSON.parse(form.y)
            }
            else {
                data = form.y
            }
            data.forEach(data_details => {
                switch (data_details.label) {
                    case "one":
                        columns_data[0].push(optionsQuestionOne[data_details.value])
                            values[0].push(data_details.value)
                        break
                    case "two":
                        columns_data[1].push(optionsQuestionTwo[data_details.value])
                            values[1].push(data_details.value)
                        break
                    case "three_one":
                        columns_data[3].push(optionsQuestionThree[data_details.value])
                            values[2].push(data_details.value)
                        break
                    case "three_two":
                        columns_data[4].push(optionsQuestionThree[data_details.value])
                            values[3].push(data_details.value)
                        break
                    case "three_three":
                        columns_data[5].push(optionsQuestionThree[data_details.value])
                            values[4].push(data_details.value)
                        break
                    case "three_four":
                        columns_data[6].push(optionsQuestionThree[data_details.value])
                            values[5].push(data_details.value)
                        break
                    case "three_five":
                        columns_data[7].push(optionsQuestionThree[data_details.value])
                            values[6].push(data_details.value)
                        break
                    case "three_six":
                        columns_data[8].push(optionsQuestionThree[data_details.value])
                            values[7].push(data_details.value)
                        break
                    case "three_seven":
                        columns_data[9].push(optionsQuestionThree[data_details.value])
                            values[8].push(data_details.value)
                        break
                    case "three_eight":
                        columns_data[10].push(optionsQuestionThree[data_details.value])
                            values[9].push(data_details.value)
                        break
                    case "three_nine":
                        columns_data[11].push(optionsQuestionThree[data_details.value])
                            values[10].push(data_details.value)
                        break
                    case "three_ten":
                        columns_data[12].push(optionsQuestionThree[data_details.value])
                            values[11].push(data_details.value)
                        break
                    case "four_one":
                        columns_data[14].push(optionsQuestionFour[data_details.value])
                            values[12].push(data_details.value)
                        break
                    case "four_two":
                        columns_data[15].push(optionsQuestionFour[data_details.value])
                            values[13].push(data_details.value)
                        break
                    case "four_three":
                        columns_data[16].push(optionsQuestionFour[data_details.value])
                            values[14].push(data_details.value)
                        break
                    case "four_four":
                        columns_data[17].push(optionsQuestionFour[data_details.value])
                            values[15].push(data_details.value)
                        break
                    case "five_one":
                        columns_data[19].push(optionsQuestionFour[data_details.value])
                            values[16].push(data_details.value)
                        break
                    case "five_two":
                        columns_data[20].push(optionsQuestionFour[data_details.value])
                            values[17].push(data_details.value)
                        break
                    case "five_three":
                        columns_data[21].push(optionsQuestionFour[data_details.value])
                            values[18].push(data_details.value)
                        break
                    case "six":
                        columns_data[22].push(optionsQuestionSix[data_details.value])
                            values[19].push(data_details.value)
                        break
                    case "seven":
                        columns_data[23].push(optionsQuestionSix[data_details.value])
                            values[20].push(data_details.value)
                        break
                    case "eight":
                        columns_data[24].push(optionsQuestionEight[data_details.value])
                            values[21].push(data_details.value)
                        break
                    case "nine_one":
                        columns_data[26].push(optionsQuestionNine[data_details.value])
                            values[22].push(data_details.value)
                        break
                    case "nine_two":
                        columns_data[27].push(optionsQuestionNine[data_details.value])
                            values[23].push(data_details.value)
                        break
                    case "nine_three":
                        columns_data[28].push(optionsQuestionNine[data_details.value])
                            values[24].push(data_details.value)
                        break
                    case "nine_four":
                        columns_data[29].push(optionsQuestionNine[data_details.value])
                            values[25].push(data_details.value)
                        break
                    case "nine_five":
                        columns_data[30].push(optionsQuestionNine[data_details.value])
                            values[26].push(data_details.value)
                        break
                    case "nine_six":
                        columns_data[31].push(optionsQuestionNine[data_details.value])
                            values[27].push(data_details.value)
                        break
                    case "nine_seven":
                        columns_data[32].push(optionsQuestionNine[data_details.value])
                            values[28].push(data_details.value)
                        break
                    case "nine_eight":
                        columns_data[33].push(optionsQuestionNine[data_details.value])
                            values[29].push(data_details.value)
                        break
                    case "nine_nine":
                        columns_data[34].push(optionsQuestionNine[data_details.value])
                            values[30].push(data_details.value)
                        break
                    case "ten":
                        columns_data[35].push(optionsQuestionNine[data_details.value])
                            values[31].push(data_details.value)
                        break
                    case "eleven_one":
                        columns_data[37].push(optionsQuestionEleven[data_details.value])
                            values[32].push(data_details.value)
                        break
                    case "eleven_two":
                        columns_data[38].push(optionsQuestionEleven[data_details.value])
                            values[33].push(data_details.value)
                        break
                    case "eleven_three":
                        columns_data[39].push(optionsQuestionEleven[data_details.value])
                            values[34].push(data_details.value)
                        break
                    case "eleven_four":
                        columns_data[40].push(optionsQuestionEleven[data_details.value])
                            values[35].push(data_details.value)
                        break
                    case "registered_by":
                        if (data_details.value !== -1) {
                            if (data_details.value === props.accountInformation.username || (props.accountInformation.anonymised_patient === false && props.accountInformation.readOnly === false)) {
                                columns_data[41].push(data_details.value)
                            }
                            else {
                                columns_data[41].push("")
                            }
                        }
                        break                        
                }
            })
        })

        values.forEach(value => {
            let converted_values
            switch(value[0]) {
                case 1:
                case 2:
                case 22:
                case 23:
                case 24:
                case 26:
                case 27:
                case 30:
                case 34:
                case 36:
                    converted_values = [100,75,50,25,0]
                    break
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                    converted_values = [0,50,100]
                    break
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                    converted_values = [0,100]
                    break
                case 20:
                case 21:
                    converted_values = [100,66,33,0]
                    break
                case 25:
                case 28:
                case 29:
                case 31:
                case 32:
                case 33:
                case 35:
                    converted_values = [0,25,50,75,100]
                    break
            }
            let i = 1
            while (value[i] !== undefined) {
                value[i] = converted_values[value[i]]
                i++
            }
        })
        let values_by_date = []
        let i = 1
        while (values[0][i] !== undefined) {
            values_by_date.push([])
            i++
        }
        i = 0
        while (values[i] !== undefined) {
            let j = 1
            while (values[i][j] !== undefined) {
                values_by_date[j-1].push(values[i][j])
                j++;
            }
            i++
        }
        i = 0
        while (values_by_date[i] !== undefined) {
            let decimals = 2
            averages[0].push(makeAverage(values_by_date[i], [2,3,4,5,6,7,8,9,10,11], decimals))
            averages[1].push(makeAverage(values_by_date[i], [12,13,14,15], decimals))
            averages[2].push(makeAverage(values_by_date[i], [16,17,18], decimals))
            averages[3].push(makeAverage(values_by_date[i], [22,26,28,30], decimals))
            averages[4].push(makeAverage(values_by_date[i], [23,24,25,27,29], decimals))
            averages[5].push(makeAverage(values_by_date[i], [19,31], decimals))
            averages[6].push(makeAverage(values_by_date[i], [20,21], decimals))
            averages[7].push(makeAverage(values_by_date[i], [0,32,33,34,35], decimals))
            averages[8].push(makeAverage(values_by_date[i], [1], decimals))
            i++
        }

    return (

        <div style={{ 
            width: "100%", 
            height: "100%", 
            overflow: "auto" 
        }}>

            <table
              className="table table-striped table-bordered"
            style={{ 
                fontSize: "90%", 
                width: "100%" 
            }}                
            >
                <thead>
                    <tr>
                    {columns_hours.map((column, index) => (
                        <th key={`h-${index}`}>
                            {column}
                        </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                {averages.map((column, index) => (
                    <React.Fragment key={`avg-${index}`}>
                        {display_formSF36GraphColumns(column, columns_hours.length)}
                    </React.Fragment>
                ))}

                {columns_data.map((column, index) => (
                    <React.Fragment key={`data-${index}`}>
                        {display_formAlimentationGraphColumns(column, columns_hours.length, 1)}
                    </React.Fragment>
                ))}
                </tbody>
            </table>
    </div>

);
 
    }
}

const display_MDASIGraph = (props, new_window) => {
    let columns_hours = [""]
    let multiple_dates = false
    let registered_by = <FormattedMessage id="form.unknown" defaultMessage="Unknown" />
    if (props.profileData.Patient_Data.mdasi.form_res.length > 1) {
        let first_date = new Date(props.profileData.Patient_Data.mdasi.form_res[0].x)
        let last_date = new Date(props.profileData.Patient_Data.mdasi.form_res[props.profileData.Patient_Data.mdasi.form_res.length - 1].x)
        if (
            first_date.getDate() !== last_date.getDate()
            || first_date.getMonth() !== last_date.getMonth()
            || first_date.getFullYear() !== last_date.getFullYear()
            ) {
            multiple_dates = true
        }
    }

    if (props.accountInformation.role !== "admin" && props.accountInformation.role !== "staff") {
        props.profileData.Patient_Data.mdasi.form_res.forEach(form => {
            let date = new Date(form.x)
            if (multiple_dates) {
                let new_date = date.getDate() + '/'
                if ((date.getMonth() + 1) > 9) {
                    new_date += (date.getMonth() + 1) + '/'
                }
                else {
                    new_date += "0" + (date.getMonth() + 1) + '/'
                }
                new_date += date.getFullYear() + ' '
                new_date += date.toTimeString().split(':')[0] + ":"
                new_date += date.toTimeString().split(':')[1]
                columns_hours.push(new_date)
            }
            else {
                let new_date = ""
                new_date += date.toTimeString().split(':')[0] + ":"
                new_date += date.toTimeString().split(':')[1]
                columns_hours.push(new_date)
            }


            return(
                <table
                  className="table table-striped table-bordered"
                  style={{width:"100%", overflow:"auto", fontSize:"80%"}}
                >
                    <thead>
                        <tr>
                            {columns_hours.map((column) => (
                                <th>{column}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        <tr><td></td><td></td><td></td></tr>
                    </tbody>
                </table>
            )
        })
    }
    else {
        let columns_data = [
            [<FormattedMessage id="mdasi.form.severity.title_simple" defaultMessage="Severity of symptoms" />],
            [<FormattedMessage id="mdasi.form.severity.one" defaultMessage="The most intense pain" />],
            [<FormattedMessage id="mdasi.form.severity.two" defaultMessage="The most important fatigue" />],
            [<FormattedMessage id="mdasi.form.severity.three" defaultMessage="" />],
            [<FormattedMessage id="mdasi.form.severity.four" defaultMessage="" />],
            [<FormattedMessage id="mdasi.form.severity.five" defaultMessage="" />],
            [<FormattedMessage id="mdasi.form.severity.six" defaultMessage="" />],
            [<FormattedMessage id="mdasi.form.severity.seven" defaultMessage="" />],
            [<FormattedMessage id="mdasi.form.severity.eight" defaultMessage="" />],
            [<FormattedMessage id="mdasi.form.severity.nine" defaultMessage="" />],
            [<FormattedMessage id="mdasi.form.severity.ten" defaultMessage="" />],
            [<FormattedMessage id="mdasi.form.severity.eleven" defaultMessage="" />],
            [<FormattedMessage id="mdasi.form.severity.twelve" defaultMessage="The importance of vomiting" />],
            [<FormattedMessage id="mdasi.form.severity.thirteen" defaultMessage="How important are sensations of numbness or tingling" />],
            [<FormattedMessage id="mdasi.form.impact.title_simple" defaultMessage="Impact of symptoms" />],
            [<FormattedMessage id="mdasi.form.impact.one" defaultMessage="General activity" />],
            [<FormattedMessage id="mdasi.form.impact.two" defaultMessage="Mood" />],
            [<FormattedMessage id="mdasi.form.impact.three" defaultMessage="Work (including housework)" />],
            [<FormattedMessage id="mdasi.form.impact.four" defaultMessage="Relationships with others" />],
            [<FormattedMessage id="mdasi.form.impact.five" defaultMessage="Walking ability" />],
            [<FormattedMessage id="mdasi.form.impact.six" defaultMessage="The spirit" />],
            [<FormattedMessage id="form.registered_by" defaultMessage="Registered by" />],
        ]

        let multiple_dates = false
        if (props.profileData.Patient_Data.mdasi.form_res.length > 1) {
            let first_date = new Date(props.profileData.Patient_Data.mdasi.form_res[0].x)
            let last_date = new Date(props.profileData.Patient_Data.mdasi.form_res[props.profileData.Patient_Data.mdasi.form_res.length - 1].x)
            if (
                first_date.getDate() !== last_date.getDate()
                || first_date.getMonth() !== last_date.getMonth()
                || first_date.getFullYear() !== last_date.getFullYear()
                ) {
                multiple_dates = true
            }
        }

        props.profileData.Patient_Data.mdasi.form_res.forEach(form => {
            let date = new Date(form.x)
            if (multiple_dates) {
                let new_date = date.getDate() + '/'
                if ((date.getMonth() + 1) > 9) {
                    new_date += (date.getMonth() + 1) + '/'
                }
                else {
                    new_date += "0" + (date.getMonth() + 1) + '/'
                }
                new_date += date.getFullYear() + ' '
                new_date += date.toTimeString().split(':')[0] + ":"
                new_date += date.toTimeString().split(':')[1]
                columns_hours.push(new_date)
            }
            else {
                let new_date = ""
                new_date += date.toTimeString().split(':')[0] + ":"
                new_date += date.toTimeString().split(':')[1]
                columns_hours.push(new_date)
            }
            let data = JSON.parse(form.y)
            data.forEach(data_details => {
                switch (data_details.label) {            
                    case "severity_one":
                        columns_data[1].push(data_details.value)
                        break
                    case "severity_two":
                        columns_data[2].push(data_details.value)
                        break
                    case "severity_three":
                        columns_data[3].push(data_details.value)
                        break
                    case "severity_four":
                        columns_data[4].push(data_details.value)
                        break
                    case "severity_five":
                        columns_data[5].push(data_details.value)
                        break
                    case "severity_six":
                        columns_data[6].push(data_details.value)
                        break
                    case "severity_seven":
                        columns_data[7].push(data_details.value)
                        break
                    case "severity_height":
                        columns_data[8].push(data_details.value)
                        break
                    case "severity_nine":
                        columns_data[9].push(data_details.value)
                        break
                    case "severity_ten":
                        columns_data[10].push(data_details.value)
                        break
                    case "severity_eleven":
                        columns_data[11].push(data_details.value)
                        break
                    case "severity_twelve":
                        columns_data[12].push(data_details.value)
                        break
                    case "severity_thirteen":
                        columns_data[13].push(data_details.value)
                        break
                    case "impact_one":
                        columns_data[15].push(data_details.value)
                        break
                    case "impact_two":
                        columns_data[16].push(data_details.value)
                        break
                    case "impact_three":
                        columns_data[17].push(data_details.value)
                        break
                    case "impact_four":
                        columns_data[18].push(data_details.value)
                        break
                    case "impact_five":
                        columns_data[19].push(data_details.value)
                        break
                    case "impact_six":
                        columns_data[20].push(data_details.value)
                        break
                    case "registered_by":
                        if (data_details.value !== -1) {
                            if (data_details.value === props.accountInformation.username || (props.accountInformation.anonymised_patient === false && props.accountInformation.readOnly === false)) {
                                columns_data[21].push(data_details.value)
                        }
                            else {
                                columns_data[21].push("")
                            }
                        }
                        break                            
                }
            })
        })
        return (
            <div style={{ 
                    width: "100%", 
                    height: "100%", 
                    maxHeight: "100%", 
                    overflow: "auto" 
                }}>
            <table
              className="table table-striped table-bordered"
                    style={{ 
                        fontSize: "90%", 
                        width: "100%" 
                    }}
            >
                <thead>
                    <tr>

                            {columns_hours.map((column, index) => (
                                <th key={`th-${index}`}>{column}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>

                        {columns_data.map((column, index) => (
                            <React.Fragment key={`tr-${index}`}>
                                {display_formAlimentationGraphColumns(column, columns_hours.length, 1)}
                            </React.Fragment>
                        ))}
                </tbody>
            </table>
            </div>
        );
    }
}

const display_AlimentationGraph = (props, new_window) => {
    let columns_hours = [""]
    let multiple_dates = false
    let registered_by = <FormattedMessage id="form.unknown" defaultMessage="Unknown" />
    if (props.profileData.Patient_Data.alimentation.form_res.length > 1) {
        let first_date = new Date(props.profileData.Patient_Data.alimentation.form_res[0].x)
        let last_date = new Date(props.profileData.Patient_Data.alimentation.form_res[props.profileData.Patient_Data.alimentation.form_res.length - 1].x)
        if (
            first_date.getDate() !== last_date.getDate()
            || first_date.getMonth() !== last_date.getMonth()
            || first_date.getFullYear() !== last_date.getFullYear()
            ) {
            multiple_dates = true
        }
    }

    if (props.accountInformation.role !== "admin" && props.accountInformation.role !== "staff") {
        props.profileData.Patient_Data.alimentation.form_res.forEach(form => {
            let date = new Date(form.x)
            if (multiple_dates) {
                let new_date = date.getDate() + '/'
                if ((date.getMonth() + 1) > 9) {
                    new_date += (date.getMonth() + 1) + '/'
                }
                else {
                    new_date += "0" + (date.getMonth() + 1) + '/'
                }
                new_date += date.getFullYear() + ' '
                new_date += date.toTimeString().split(':')[0] + ":"
                new_date += date.toTimeString().split(':')[1]
                columns_hours.push(new_date)
            }
            else {
                let new_date = ""
                new_date += date.toTimeString().split(':')[0] + ":"
                new_date += date.toTimeString().split(':')[1]
                columns_hours.push(new_date)
            }


            return(
                <table
                  className="table table-striped table-bordered"
                  style={{width:"100%", overflow:"auto", fontSize:"80%"}}
                >
                    <thead>
                        <tr>
                            {columns_hours.map((column) => (
                                <th>{column}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        <tr><td></td><td></td><td></td></tr>
                    </tbody>
                </table>
            )
        })
    }
    else {
        let columns_data = [
            [<FormattedMessage id="alimentation.form.transit.title" defaultMessage="Transit" />],
            [<FormattedMessage id="alimentation.form.display.farts" defaultMessage="Flatulences" />],
            [<FormattedMessage id="alimentation.form.display.bowel_movement" defaultMessage="Bowel movement" />],
            [<FormattedMessage id="alimentation.form.display.nausea" defaultMessage="Nausea and vomitting" />],
            [<FormattedMessage id="alimentation.form.pain.title" defaultMessage="Pain / Analgesics" />],
            [<FormattedMessage id="alimentation.form.display.pain_treatment_efficiency" defaultMessage="Treatment efficiency" />],
            [<FormattedMessage id="alimentation.form.display.pain_treatment_help" defaultMessage="Treatment help needed" />],
            [<FormattedMessage id="alimentation.form.alimentation.title" defaultMessage="Nourishment" />],
            [<FormattedMessage id="alimentation.form.display.alimentation_water" defaultMessage="Water/soft drinks" />],
            [<FormattedMessage id="alimentation.form.display.alimentation_yogurt" defaultMessage="Yogurt/compote" />],
            [<FormattedMessage id="alimentation.form.display.alimentation_light" defaultMessage="Light food such as mashed potatoes/ham" />],
            [<FormattedMessage id="alimentation.form.display.alimentation_almost_normal" defaultMessage="Near-normal alimentation" />],
            [<FormattedMessage id="alimentation.form.display.alimentation_increase" defaultMessage="Increasing alimentation" />],
            [<FormattedMessage id="alimentation.form.display.alimentation_help" defaultMessage="Alimentation help needed" />],
            [<FormattedMessage id="form.registered_by" defaultMessage="Registered by" />],
        ]
        let multiple_dates = false
        if (props.profileData.Patient_Data.alimentation.form_res.length > 1) {
            let first_date = new Date(props.profileData.Patient_Data.alimentation.form_res[0].x)
            let last_date = new Date(props.profileData.Patient_Data.alimentation.form_res[props.profileData.Patient_Data.alimentation.form_res.length - 1].x)
            if (
                first_date.getDate() !== last_date.getDate()
                || first_date.getMonth() !== last_date.getMonth()
                || first_date.getFullYear() !== last_date.getFullYear()
                ) {
                multiple_dates = true
            }
        }
        props.profileData.Patient_Data.alimentation.form_res.forEach(form => {
            let date = new Date(form.x)
            if (multiple_dates) {
                let new_date = date.getDate() + '/'
                if ((date.getMonth() + 1) > 9) {
                    new_date += (date.getMonth() + 1) + '/'
                }
                else {
                    new_date += "0" + (date.getMonth() + 1) + '/'
                }
                new_date += date.getFullYear() + ' '
                new_date += date.toTimeString().split(':')[0] + ":"
                new_date += date.toTimeString().split(':')[1]
                columns_hours.push(new_date)
            }
            else {
                let new_date = ""
                new_date += date.toTimeString().split(':')[0] + ":"
                new_date += date.toTimeString().split(':')[1]
                columns_hours.push(new_date)
            }
            let data = JSON.parse(form.y)
            data.forEach(data_details => {
                switch (data_details.label) {
                    case "transit_one":
                        columns_data[1].push(convertYesNoMaybe(data_details.value))
                        break
                    case "transit_two":
                        columns_data[2].push(convertYesNoMaybe(data_details.value))
                        break
                    case "transit_three":
                        columns_data[3].push(convertYesNoMaybe(data_details.value))
                        break
                    case "pain_one":
                        columns_data[5].push(convertYesNoMaybe(data_details.value))
                        break
                    case "pain_two":
                        columns_data[6].push(convertYesNoMaybe(data_details.value))
                        break
                    case "alimentation_one":
                        columns_data[8].push(convertYesNoMaybe(data_details.value[0]))
                        columns_data[9].push(convertYesNoMaybe(data_details.value[1]))
                        columns_data[10].push(convertYesNoMaybe(data_details.value[2]))
                        columns_data[11].push(convertYesNoMaybe(data_details.value[3]))
                        break
                    case "alimentation_two":
                        columns_data[12].push(convertYesNoMaybe(data_details.value))
                        break
                    case "alimentation_three":
                        columns_data[13].push(convertYesNoMaybe(data_details.value))
                        break
                    case "registered_by":
                        if (data_details.value !== -1) {
                            if (data_details.value === props.accountInformation.username || (props.accountInformation.anonymised_patient === false && props.accountInformation.readOnly === false)) {
                                columns_data[14].push(data_details.value)
                            }
                            else {
                                columns_data[14].push("")
                            }
                        }
                        break                        
                }
            })
        })
        
        return (
            <div style={{ width: "100%", overflowX: "auto" }}>
            <table
              className="table table-striped table-bordered"
                    style={{ width: "100%", fontSize: "80%", borderCollapse: "collapse" }}
            >
                <thead>
                    <tr>
                            {columns_hours.map((column, index) => (
                                <th key={`th-${index}`}>
                                    {column}
                                </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {columns_data.map((column) => {
                                return (Utils.display_formAlimentationGraphColumns(column, columns_hours.length, 1))
                    })}
                </tbody>
            </table>
            </div>
        )
    }
}

// Build one floating bar per continuous usage session, positioned on a 24h
// "noon to noon" clock axis (12 = noon, 24 = midnight, 36 = noon next day).
// Sessions are grouped into the noon-to-noon window that contains their start,
// so a night session (e.g. 22:00 -> 06:00) shows as a single bar around midnight.
const buildNivUsageSessionBars = (sessions) => {
    let bars = []
    if (sessions === undefined || sessions === null) {
        return bars
    }

    // Normalize and sort sessions by start date
    let intervals = []
    sessions.forEach((session) => {
        let start = Number(session.start)
        let end = Number(session.end)
        if (!isNaN(start) && !isNaN(end) && end > start) {
            intervals.push({start: start, end: end})
        }
    })
    intervals.sort((a, b) => a.start - b.start)

    // Merge consecutive sessions (back-to-back, gap <= tolerance) into a single
    // continuous bar so several consecutive hours show as one bar, not stacked ones.
    const MERGE_GAP_MS = 60000   // 1 minute tolerance (joins adjacent hourly slots)
    let merged = []
    intervals.forEach((it) => {
        let last = merged[merged.length - 1]
        if (last !== undefined && (it.start - last.end) <= MERGE_GAP_MS) {
            if (it.end > last.end) {
                last.end = it.end
            }
        }
        else {
            merged.push({start: it.start, end: it.end})
        }
    })

    merged.forEach((session) => {
        let start = session.start
        // round the end up to the minute: a slot ends at xh59:59.999 (1 ms before the
        // next hour), so it must read as the next round time (e.g. 09:59:59.999 -> 10:00)
        let end = Math.ceil(session.end / 60000) * 60000
        // reference noon = noon of the 24h window [noon, noon+24h) containing start
        let refNoon = new Date(start)
        refNoon.setHours(12, 0, 0, 0)
        if (start < refNoon.getTime()) {
            refNoon.setDate(refNoon.getDate() - 1)
        }
        let refNoonMs = refNoon.getTime()
        let yStart = 12 + (start - refNoonMs) / 3600000
        let yEnd = 12 + (end - refNoonMs) / 3600000
        if (yEnd > 36) {                 // clamp sessions that run past the next noon
            yEnd = 36
        }
        // x = midnight of the day that begins this noon-to-noon window
        let refDay = new Date(refNoonMs)
        refDay.setHours(0, 0, 0, 0)
        bars.push({x: refDay.getTime(), y: [yStart, yEnd], _start: start, _end: end})
    })
    return bars
}

const display_breathingGraph_NIVUsage = (props, new_window, popupNum) => {
    let usage_sessions = buildNivUsageSessionBars(props.profileData.Patient_Data.breathing.niv_sessions)

    return(
        <GraphUsageSessions
            style={{display: "flex", height: "100%", width: "100%", justifyContent:'center', alignItems:'center'}}
            new_window =            {new_window}
            onEnlarge =             {props.onEnlarge}
            fillHeight =            {popupNum !== undefined}
            id_graph =              {props.profileData.Patient_Data.id_patient + (popupNum || 6)}
            title =                 {props.intl.formatMessage({id: "patientConstants.VNIusage"})}
            curve_name =            {props.intl.formatMessage({id: "patientConstants.VNIusage"})}
            min_x =                 {new Date(props.dateSelected[0]).getTime()}
            max_x =                 {new Date(props.dateSelected[1]).getTime()}
            curve =                 {usage_sessions}
            curve_color =           {'#2896E5'}
        />
    )
}

const display_breathingGraph_NIVLeakage = (props, new_window, popupNum) => {
    let respiratory_leak_curve = []
    let date_list = []

    //compute average value per day
    props.profileData.Patient_Data.breathing.respiratory_leak.forEach((res, i) => {
        //get the data leak value
        let resp_value = Number(res.y)
        //get the datetime of the data
        let convertedDate = dateToMidnight(res.x)

        // Search in tmp date_list if same date already stored
        let date_list_index = date_list.findIndex((e) => e.date.getTime() === convertedDate.getTime())
        //if the date_list doesn't contain the day, push the value and set nb val to 1
        if (date_list_index === -1) {
            date_list.push({date: convertedDate, total: resp_value, parts: 1})
        }
        else {
            // Add value
            let temp_value = date_list[date_list_index].total + resp_value
            // increase nb val
            let part_value = date_list[date_list_index].parts + 1
            date_list[date_list_index] = {date: convertedDate, total: temp_value, parts: part_value}
        }
    })

    //for each day with data
    for (var i = date_list.length-1; i >= 0; i--){
        // Compute average
        respiratory_leak_curve.push(  {x: date_list[i].date, y: date_list[i].total / date_list[i].parts});
    }

    // Compute the median leak over the days that actually have a leak (exclude the no-leak days at 0)
    let medianLeak = null
    let medianLeakLabel = ''
    let leakValues = respiratory_leak_curve
        .map((point) => point.y)
        .filter((value) => !Number.isNaN(value) && value > 0)
        .sort((a, b) => a - b)
    if (leakValues.length > 0) {
        let mid = Math.floor(leakValues.length / 2)
        medianLeak = leakValues.length % 2 !== 0
            ? leakValues[mid]
            : (leakValues[mid - 1] + leakValues[mid]) / 2
        medianLeakLabel = 'Fuite médiane: ' + Math.round(medianLeak) + ' ' + props.intl.formatMessage({id: "patientConstants.VNIleakageUnit"})
    }

    let alertPointLeak = AlertManager.getLastAlertMax7days(props.profileData.Patient_Data.alerts_triggered, "breathing_leakage_alert")
    //get the datetime of the data
    let x = 0;
    while (alertPointLeak[x]) {
        let convertedDate = dateToMidnight(alertPointLeak[x].x)
        alertPointLeak[x].x = convertedDate.toISOString()
        x++
    }

    return(
        <GraphOneBar
            style={{display: "flex", height: "100%", width: "100%", justifyContent:'center', alignItems:'center'}}
            new_window =            {new_window}
            onEnlarge =             {props.onEnlarge}
            id_graph =              {props.profileData.Patient_Data.id_patient + (popupNum || 13)}
            curve_name =            {props.intl.formatMessage({id: "patientConstants.VNIleakage"})}
            min_x =                 {new Date(props.dateSelected[0]).getTime()}
            max_x =                 {new Date(props.dateSelected[1]).getTime()}
            curve =                 {respiratory_leak_curve}
            curve_color =           {'#e5ac28'}
            y_axis_title =          {props.intl.formatMessage({id: "patientConstants.VNIleakage"})+ ' (' + props.intl.formatMessage({id: "patientConstants.VNIleakageUnit"}) + ')'}
            threshold_name =        {props.intl.formatMessage({id: "graph.threshold.leak", defaultMessage: "Alerte fuite"})}
            threshold =             {props.profileData.Patient_Data.MaxBreathingLeakageDrawing}
            threshold_color =       {'#e5ac28'}
            min =                   {0}
            max =                   {30}
            alertPoints =           {alertPointLeak}
            medianLine =            {medianLeak}
            medianLineLabel =       {medianLeakLabel}
        />
    )
}

const display_breathingGraph_NIVBreathingRate = (props, new_window, popupNum) => {
    let respiratory_rate_curve = props.profileData.Patient_Data.breathing.respiratory_rate
    let alertPointRespiratoryRate = AlertManager.getLastAlertMax7days(props.profileData.Patient_Data.alerts_triggered, "breathing_rate_alert")

    let alertPointReminder = AlertManager.getLastAlertMax7days(props.profileData.Patient_Data.alerts_triggered, "reminder_alert")
    return(
        <GraphOneCurve
            style={{display: "flex", height: "100%", width: "100%", justifyContent:'center', alignItems:'center'}}
            new_window =        {new_window}
            onEnlarge =         {props.onEnlarge}
            id_graph =          {props.profileData.Patient_Data.id_patient + (popupNum || 7)}
            min_x =             {new Date(props.dateSelected[0]).getTime()}
            max_x =             {new Date(props.dateSelected[1]).getTime()}
            curve_name =        {props.intl.formatMessage({id: "patientConstants.breathingRate"})}
            curve =             {respiratory_rate_curve}
            curve_color =       {'#2896E5'}
            y_axis_title =      {props.intl.formatMessage({id: "patientConstants.breathingRate"})+ ' (' + props.intl.formatMessage({id: "patientConstants.breathingRateUnit"}) + ')'}   
            threshold_name =    {props.intl.formatMessage({id: "graph.threshold.breathingRate", defaultMessage: "Alerte fréquence respi."})}
            threshold =         {props.profileData.Patient_Data.MaxBreathingRateDrawing}
            threshold_color =   {'#2896E5'}
            min =               {0}
            max =               {70}
            alertPoints =       {alertPointRespiratoryRate}
            alertPointsReminder = {alertPointReminder}
            currentTime =       {props.profileData.Patient_Data.currentTime}
            pointRadius =       {props.pointRadius}
        />
    )
}

const display_breathingGraph_AHI = (props, new_window, popupNum) => {
    // sort a copy by timestamp so the line connects consecutive points in time (merge order is not guaranteed monotonic)
    let ahi_curve = (props.profileData.Patient_Data.breathing.respiratory_ahi || []).slice().sort((a, b) => a.x - b.x)
    let alertPointAhi = AlertManager.getLastAlertMax7days(props.profileData.Patient_Data.alerts_triggered, "breathing_ahi_alert")

    let alertPointReminder = AlertManager.getLastAlertMax7days(props.profileData.Patient_Data.alerts_triggered, "reminder_alert")
    return(
        <GraphOneCurve
            style={{display: "flex", height: "100%", width: "100%", justifyContent:'center', alignItems:'center'}}
            new_window =        {new_window}
            onEnlarge =         {props.onEnlarge}
            id_graph =          {props.profileData.Patient_Data.id_patient + (popupNum || 11)}
            min_x =             {new Date(props.dateSelected[0]).getTime()}
            max_x =             {new Date(props.dateSelected[1]).getTime()}
            curve_name =        {props.intl.formatMessage({id: "patientConstants.ahi"})}
            curve =             {ahi_curve}
            curve_color =       {'#2896E5'}
            showLine =          {true}
            lineWidth =         {1}
            lineColor =         {'rgba(40, 150, 229, 0.5)'}
            pointRadiusScale =  {0.92}
            pointColor =        {'rgba(40, 150, 229, 0.8)'}
            y_axis_title =      {props.intl.formatMessage({id: "patientConstants.ahi"})+ ' (' + props.intl.formatMessage({id: "patientConstants.ahiUnit"}) + ')'}
            threshold_name =    {props.intl.formatMessage({id: "graph.threshold.ahi", defaultMessage: "Alerte IAH"})}
            threshold =         {props.profileData.Patient_Data.MaxBreathingAhiDrawing}
            threshold_color =   {'#DB2828'}
            threshold2_name =   {props.intl.formatMessage({id: "graph.threshold.ahiTarget", defaultMessage: "Objectif IAH < 10"})}
            threshold2 =        {props.profileData.Patient_Data.MaxBreathingAhiObjectiveDrawing}
            threshold2_color =  {'#21BA45'}
            showThresholdLegend = {true}
            min =               {0}
            max =               {50}
            alertPoints =       {alertPointAhi}
            alertPointsReminder = {alertPointReminder}
            currentTime =       {props.profileData.Patient_Data.currentTime}
            pointRadius =       {props.pointRadius}
        />
    )
}

const display_breathingGraph_Leak95 = (props, new_window, popupNum) => {
    // sort a copy by timestamp so the line connects consecutive points in time (merge order is not guaranteed monotonic)
    let leak95_curve = (props.profileData.Patient_Data.breathing.respiratory_leak95 || []).slice().sort((a, b) => a.x - b.x)
    let alertPointLeak95 = AlertManager.getLastAlertMax7days(props.profileData.Patient_Data.alerts_triggered, "breathing_leakage95_alert")

    let alertPointReminder = AlertManager.getLastAlertMax7days(props.profileData.Patient_Data.alerts_triggered, "reminder_alert")
    return(
        <GraphOneCurve
            style={{display: "flex", height: "100%", width: "100%", justifyContent:'center', alignItems:'center'}}
            new_window =        {new_window}
            onEnlarge =         {props.onEnlarge}
            id_graph =          {props.profileData.Patient_Data.id_patient + (popupNum || 12)}
            min_x =             {new Date(props.dateSelected[0]).getTime()}
            max_x =             {new Date(props.dateSelected[1]).getTime()}
            curve_name =        {props.intl.formatMessage({id: "patientConstants.leak95"})}
            curve =             {leak95_curve}
            curve_color =       {'#2896E5'}
            showLine =          {true}
            lineWidth =         {1}
            lineColor =         {'rgba(40, 150, 229, 0.5)'}
            pointRadiusScale =  {0.92}
            pointColor =        {'rgba(40, 150, 229, 0.8)'}
            y_axis_title =      {props.intl.formatMessage({id: "patientConstants.leak95"})+ ' (' + props.intl.formatMessage({id: "patientConstants.VNIleakageUnit"}) + ')'}
            threshold_name =    {props.intl.formatMessage({id: "graph.threshold.leak95", defaultMessage: "Alerte fuite 95"})}
            threshold =         {props.profileData.Patient_Data.MaxBreathingLeak95Drawing}
            threshold_color =   {'#DB2828'}
            showThresholdLegend = {true}
            min =               {0}
            max =               {65}
            alertPoints =       {alertPointLeak95}
            alertPointsReminder = {alertPointReminder}
            currentTime =       {props.profileData.Patient_Data.currentTime}
            pointRadius =       {props.pointRadius}
        />
    )
}

const display_breathingGraph_OxiUsage = (props, new_window, popupNum) => {
    let alertPointReminder = AlertManager.getLastAlertMax7days(props.profileData.Patient_Data.alerts_triggered, "reminder_alert")
    return (
        <GraphOneBar
            style={{display: "flex", height: "100%", width: "100%", justifyContent:'center', alignItems:'center'}}
            new_window =        {new_window}
            onEnlarge =         {props.onEnlarge}
            id_graph =              {props.profileData.Patient_Data.id_patient + (popupNum || 9)}
            curve_name =            {props.intl.formatMessage({id: "patientConstants.VNIusage"})}
            min_x =                 {new Date(props.dateSelected[0]).getTime()}
            max_x =                 {new Date(props.dateSelected[1]).getTime()}
            y_axis_title =          {props.intl.formatMessage({id: "patientConstants.VNIusage"})+ ' (' + props.intl.formatMessage({id: "patientConstants.VNIusageUnit"}) + ')'}   
            curve =                 {props.profileData.Patient_Data.breathing.oxi_usage}
            curve_color =           {'#2896E5'}
            min =                   {0}
            max =                   {24}
            alertPointsReminder =   {alertPointReminder}
        />
    )
}

const display_breathingGraph_OxygenFlowRate = (props, new_window, popupNum) => {
    let oxygen_flow_rate_curve = props.profileData.Patient_Data.breathing.oxygen_flow_rate
    let alertPointOxygenRate = AlertManager.getLastAlertMax7days(props.profileData.Patient_Data.alerts_triggered, "breathing_oxygen_rate_alert")

    let alertPointReminder = AlertManager.getLastAlertMax7days(props.profileData.Patient_Data.alerts_triggered, "reminder_alert")
    return (
        <GraphOneCurve
            style={{display: "flex", height: "100%", width: "100%", justifyContent:'center', alignItems:'center'}}
            new_window =        {new_window}
            onEnlarge =         {props.onEnlarge}
            id_graph =          {props.profileData.Patient_Data.id_patient + (popupNum || 10)}
            min_x =             {new Date(props.dateSelected[0]).getTime()}
            max_x =             {new Date(props.dateSelected[1]).getTime()}
            curve_name =        {props.intl.formatMessage({id: "patientConstants.oxigenFlowRate"})}
            curve =             {oxygen_flow_rate_curve}
            curve_color =       {'#2896E5'}
            y_axis_title =      {props.intl.formatMessage({id: "patientConstants.oxigenFlowRate"})+ ' (' + props.intl.formatMessage({id: "patientConstants.oxigenFlowRateUnit"}) + ')'}   
            threshold_name =    {props.intl.formatMessage({id: "graph.threshold.leak", defaultMessage: "Alerte fuite"})}
            threshold =         {props.profileData.Patient_Data.MaxBreathingOxygenRateDrawing}
            threshold_color =   {'#2896E5'}
            min =               {0}
            max =               {10}
            alertPoints =       {alertPointOxygenRate}
            alertPointsReminder = {alertPointReminder}
            currentTime =       {props.profileData.Patient_Data.currentTime}
            pointRadius =       {props.pointRadius}
        />
    )
}


//Export functions to make them visible and usable in other files
const Utils = {
    cleanSmsList,
    convert_datestring_to_timeinput_string,
    convert_hour_to_utc_date,
    convertRoleToText,
    convertTextToFormattedMessageIdError,
    convertTextToFormattedMessageIdUnits,
    dataAlertColor,
    dateToMidnight,
    fillReminder,
    filterData,
    filterScaleData,
    filterHealthform,
    formatDataDisplay,
    getConvertedColor,
    getFHIRCodesFromFeatures,
    isValidJson,
    setCurrentTimePoint,
    setDefaultThreshold2,
    setMeasureColor,
    setAlertCurve,
    setLastMeasurementTimer,
    convert_date_to_YMD_string,
    convert_date_to_DMY_string,
    convert_date_to_full_date_string,
    convert_date_to_full_date_string_hepadom,
    isSameDay,
    sortDataByNames,
    splitStringToList,
    testGroupsFilter,
    reminderAlertHoursConvert,
    smsAlertParse,
    ins_check_if_data_exist,
    ins_check_valid_last_names,
    ins_check_valid_first_names,
    ins_check_valid_dates,
    ins_check_valid_birthPlace,
    ins_check_valid_sex,
    ins_convert_sex,
    ins_format_data,
    ins_format_log,
    fhir_convert_user_data,
    fhir_get_structure_data,
    fhir_get_subscription_data,
    format_fhir_response_from_datatype,
    get_reminder_from_type,
    mergeBasicOldData,
    mergeBasicNewData,
    deviceTypeToReminderType,
    fillNewReminderHours,
    checkBit,
    featureToBitNumber,
    FEATURE_NAMES,
    getFirstDevice,
    getFirstTabWithData,
    contactListsToMultiRecipient,
    makeAverage,
    testAnyModuleUsed,
    testModuleInListUsed,
    testAnyModuleUsedExcept,
    testSmartphoneDisplay,
    testIsDevicesAndGatewayAssociate,
    testIsAnyDeviceAssociate,
    testNivData,
    testOxiData,
    display_temperatureGraph,
    display_pulseOximeterGraph,
    display_tensiometerGraph,
    display_scaleGraph,
    display_painGraph,
    display_formEQ5DGraph,
    display_SF36Graph,
    display_MDASIGraph,
    display_AlimentationGraph,
    display_formAlimentationGraphColumns,
    display_breathingGraph_NIVUsage,
    display_breathingGraph_NIVLeakage,
    display_breathingGraph_NIVBreathingRate,
    display_breathingGraph_AHI,
    display_breathingGraph_Leak95,
    display_breathingGraph_OxiUsage,
    display_breathingGraph_OxygenFlowRate,
};

export default Utils;
